/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-useless-computed-key */
export default {
	['较大']: 'বড়',
	['预设']: 'পূর্বনির্ধারিত',
	['较小']: 'ছোট',
	['字级大小']: 'ফন্টের আকার',
	['页面正在加载中']: 'পেজ লোড হচ্ছে',
	['这可能需要几分钟的时间，请耐心等待']: 'এতে কয়েক মিনিট সময় লাগতে পারে, দয়া করে অপেক্ষা করুন।',
	['您所访问的页面不存在']: 'এই পেজটি পাওয়া যাচ্ছে না',
	['开始对话']: 'চ্যাট শুরু করুন',
	['充值未到帐快速通道']: 'রিচার্জ না পেলে এখানে ক্লিক করুন',
	['人工客服']: 'কৃত্রিম গ্রাহক সেবা',
	['已接听']: 'উত্তর দেওয়া হয়েছে',
	['结束对话']: 'চ্যাট শেষ করুন',
	['联络人工客服']: 'কাস্টমার কেয়ার এজেন্টের সাথে কথা বলুন',
	['重新选择智能客服']: 'স্মার্ট কাস্টমার সার্ভিস পুনরায় নির্বাচন করুন',
	['感谢您使用本次服务，烦请拨冗补充填写调查，您宝贵的意见是我们前进的动力！']: 'আমাদের পরিষেবাটি ব্যবহার করার জন্য ধন্যবাদ। অনুগ্রহ করে জরিপটি পূরণ করার জন্য সময় দিন, আপনার মূল্যবান মতামত আমাদের এগিয়ে যাওয়ার অনুপ্রেরণা।',
	['您觉得此次的服务品质如何？']: 'আমাদের সেবা আপনার কেমন লেগেছে?',
	['颗星']: 'তারা',
	['颗星(單數)']: 'তারা',
	['不评分']: 'মন্তব্য না করতে',
	['点选下方即可结束对话']: 'চ্যাট শেষ করতে নিচে ক্লিক করুন',
	['请输入您的ID']: 'আপনার আইডি লিখুন',
	['ID不能为空']: 'আইডি খালি রাখা যাবে না',
	['说明文字']: 'বিবরণী',
	['送出']: 'পাঠান',
	['系统维护中']: 'সিস্টেম রক্ষণাবেক্ষণ চলছে',
	['储存']: 'সেভ করুন',
	['确认']: 'নিশ্চিত করুন',
	['取消']: 'বাতিল করুন',
	['完成']: 'সম্পন্ন',
	['协作']: 'সহযোগিতা',
	['转接']: 'সংযোগ',
	['离开']: 'বের হন',
	['请选择服务对象开始通话']: 'সেবা প্রদানকারী নির্বাচন করুন কথা বলতে শুরু করুন',
	['请填写表单']: 'ফরম পূরণ করুন',
	['本对话已经结束']: 'এই আলোচনার ইতিমধ্যে সমাপ্ত হয়েছে',
	['客服已逾 {{second}} 秒未回应']: 'গ্রাহক সেবা {{second}} সেকেন্ড ধরে কোনও উত্তর দেয়নি',
	['历史对话']: 'ইতিহাসগত সংলাপ',
	['查无资料']: 'তথ্য পাওয়া যায়নি',
	['标签']: 'লেবেল',
	['正在输入中...']: 'লিখা হচ্ছে...',
	['于']: 'বঙ্গবন্ধু',
	['档案容量限制']: 'ফাইলের আকারের সীমা',
	['不能为空']: 'শূন্য হতে পারবে না',
	['提交']: 'জমা দিন',
	['满意度']: 'সন্তুষ্টি',
	['IP未知']: 'IP অজানা',
	['地区未知']: 'অঞ্চল অজানা',
	['使用者环境未知']: 'ব্যবহারকারীর পরিবেশ অজানা',
	['关闭']: 'বন্ধ করুন',
	['全萤幕截图成档案']: 'ফুল স্ক্রিনশট ফাইল হিসেবে সেভ করুন',
	['Mac用户']: 'ম্যাক ব্যবহারকারী',
	['Windows用户']: ' উইন্ডোজ ব্যবহারকারী',
	['Windows键']: 'উইন্ডোজ কি',
	['全萤幕截图至剪贴簿']: 'ফুল স্ক্রিনশট ক্লিপবোর্ডে কপি করুন',
	['截图完成后请直接于文字输入处贴上']: 'স্ক্রিনশট সম্পন্ন হলে দয়া করে পাঠ্য ইনপুট স্থানে সরাসরি পেস্ট করুন。',
	['使用Windows内建截图工具或者QQ软件截图功能，截图完成后请直接于文字输入处贴上']: 'Windows এর অভ্যন্তরীণ স্ক্রীনশট টুল বা QQ সফটওয়্যার স্ক্রীনশট ফিচার ব্যবহার করুন, স্ক্রীনশট সম্পন্ন হলে দয়া করে সরাসরি লেখার ইনপুট স্থানে পেস্ট করুন।',
	['截图']: 'স্ক্রীনশট',
	['档案']: 'ফাইল',
	['下载失败']: 'ডাউনলোড ব্যর্থ',
	['请输入分类名称']: 'বিভাগের নাম লিখুন',
	['新增']: 'নতুন যোগ করুন',
	['更新']: 'আপডেট',
	['请选择一个分类']: 'একটি শ্রেণী নির্বাচন করুন',
	['请输入标题']: 'শিরোনাম লিখুন',
	['请输入内文']: 'অনুগ্রহ করে মূল বিষয়টি লিখুন',
	['请上传图片']: 'ছবি আপলোড করুন',
	['快捷语']: 'ক্যুইক ভাষা',
	['图片']: 'ছবি',
	['管理分类']: 'ব্যবস্থাপনা শ্রেণীবিভাগ',
	['新增分类']: 'নতুন শ্রেণী যুক্ত করুন',
	['标题/内文']: 'শিরোনাম/বিষয়বস্তু',
	['分类']: 'বিভাগ',
	['编辑']: 'সম্পাদনা',
	['删除']: 'মুছে ফেলুন',
	['平台名称']: 'প্ল্যাটফর্মের নাম',
	['显示']: 'প্রদর্শন',
	['编辑服务平台']: 'সম্পাদনা সেবা প্ল্যাটফর্ম',
	['若有服务中的客户，无法关闭服务平台']: 'যদি পরিষেবার মধ্যে কোনও গ্রাহক থাকে, তাহলে পরিষেবা প্ল্যাটফর্ম বন্ধ করা যাবে না।',
	['确定']: 'ঠিক আছে',
	['人员列表']: 'কর্মী তালিকা',
	['服务人数']: 'সেবা সংখ্যা',
	['选择转接人员']: 'নিয়োগকারী নির্বাচন করুন',
	['按此上传图片']: 'এখানে ছবি আপলোড করুন',
	['确定要取消{{displayName}}协作邀请吗？']: 'আপনি কি নিশ্চিত যে {{displayName}} এর সহযোগিতা আমন্ত্রণ বাতিল করতে চান?',
	['确定要结束{{displayName}}的协作吗？']: 'আপনি কি নিশ্চিত যে {{displayName}} এর সহযোগিতা শেষ করতে চান?',
	['等待协作中']: 'সহযোগিতায় অপেক্ষা',
	['协作中']: 'সহযোগীতা',
	['负责人']: 'দায়িত্বশীল',
	['已选择']: 'নির্বাচিত',
	['可协作人数已满']: 'সহযোগী সংখ্যা পূর্ণ হয়েছে',
	['选择协作人员']: 'সহযোগী নির্বাচন',
	['提示']: 'পরামর্শ',
	['请输入讯息']: 'মেসেজ লিখুন',
	['确定已經完成？']: 'সুনিশ্চিত যে এটা সম্পন্ন হয়েছে?',
	['常用图片']: 'প্রুজ্জল ছবি',
	['用户']: 'ব্যবহারকারী',
	['个人']: 'ব্যক্তিগত',
	['公共']: 'জনসাধারণ',
	['开始谈话']: 'আলাপকথন শুরু করুন',
	['等待中']: 'অপেক্ষায়',
	['客户已离开对话']: 'গ্রাহক কথোপকথন ত্যাগ করেছেন',
	['正在转接给']: 'স্থানান্তরিত করা হচ্ছে',
	['邀请你加入协作']: 'তোমাকে সহযোগিতায় যোগ দিতে আমন্ত্রণ জানাচ্ছি',
	['请求转接']: 'অনুরোধ স্থানান্তর',
	['正在服务中']: 'সেবা চলছে',
	['编辑平台']: 'সম্পাদকীয় প্ল্যাটফর্ম',
	['您的连线已中断']: 'আপনার সংযোগ বিচ্ছিন্ন হয়েছে',
	['正尝试重新连线']: 'সঠিকভাবে পুনরায় সংযোগ করার চেষ্টা করা হচ্ছে',
	['重新登入']: 'পুনরায় লগইন করুন',
	['请先登入']: 'আগে লগইন করুন',
	['帐号']: 'অ্যাকাউন্ট',
	['帐号不能为空']: 'অ্যাকাউন্ট শূন্য হতে পারবে না',
	['请输入帐号']: 'অ্যাকাউন্ট নম্বর দিন',
	['密码']: 'পাসওয়ার্ড',
	['密码不能为空']: 'পাসওয়ার্ড খালি থাকতে পারে না',
	['请输入密码']: 'দয়া করে পাসওয়ার্ড প্রবেশ করুন',
	['登录']: 'লগ ইন',
	['客服系统客服端']: 'কাস্টমার সার্ভিস সিস্টেম ক্লায়েন্ট',
	['平台异动，请重新整理']: 'প্ল্যাটফর্ম পরিবর্তন, দয়া করে পুনরায় রিফ্রেশ করুন',
	['客服系统升级维护中，请您晚点再联系线上客服，谢谢']: 'গ্রাহক সেবা ব্যবস্থা আপগ্রেডের জন্য রক্ষণাবেক্ষণ করা হচ্ছে, দয়া করে কিছু সময় পরে অনলাইন গ্রাহক সেবার সাথে যোগাযোগ করুন, ধন্যবাদ।',
	['客服系统进入升级维护作业，很抱歉中断您的对话，请您晚点再联系线上客服']: 'কাস্টমার সার্ভিস সিস্টেম আপগ্রেড রক্ষণাবেক্ষণের কাজ শুরু করেছে, আপনার আলোচনা বিঘ্নিত করার জন্য দুঃখিত, দয়া করে পরে আবার অনলাইন কাস্টমার সার্ভিসের সাথে যোগাযোগ করুন।',
	['请稍后再试']: 'অনুগ্রহ করে পরে আবার চেষ্টা করুন',
	['是']: 'হ্যাঁ',
	['否']: 'না',
	['等于']: 'সমান',
	['包含']: 'সম包含',
	['排除']: 'বর্জন',
	['大于']: 'বড়',
	['少于']: 'কম ',
	['数量区间']: 'পরিমাণ পরিসীমা',
	['客服对话数']: 'কাস্টমার সেবা কথোপকথন সংখ্যা',
	['客戶对话数']: 'গ্রাহক কথোপকথন সংখ্যা',
	['即时资讯']: 'তাত্ক্ষণিক তথ্য',
	['报表分析']: 'প্রতিবেদন বিশ্লেষণ',
	['平均通话时间']: 'গড় কল সময়',
	['回覆通话数']: 'রিপ্লাই কল সংখ্যা',
	['平均等待时间']: 'গড় অপেক্ষার সময়',
	['客户满意度']: 'গ্রাহক সন্তুষ্টি',
	['历史对话记录']: 'ইতিহাসের আলোচনা রেকর্ড',
	['操作日志']: 'অপারেশন লগ',
	['智能客服设定']: 'বুদ্ধিমত্তা গ্রাহক পরিষেবা সেটিং',
	['机器人设定']: 'রম রোবট সেটিং',
	['版本管理']: 'সংস্করণ পরিচালনা',
	['档案总览']: 'ফাইলের সারসংক্ষেপ',
	['设定']: 'নির্ধারণ',
	['公司管理']: 'কোম্পানি ব্যবস্থাপনা',
	['维修管理']: 'মেরামত ব্যবস্থাপনা',
	['一般设定']: 'সাধারণ সেটিংস',
	['公告管理']: 'বিজ্ঞপ্তি ব্যবস্থাপনা',
	['帐号管理']: 'অ্যাকাউন্ট ম্যানেজমেন্ট',
	['平台管理']: 'প্ল্যাটফর্ম ব্যবস্থাপনা',
	['角色管理']: 'ভূমিকা পরিচালনা',
	['团队管理']: ' দলের управление',
	['标签管理']: 'লেবেল ব্যবস্থাপন',
	['查询']: 'অনুসন্ধান',
	['重置']: 'পুনঃসেট করুন',
	['今天']: 'আজ',
	['昨天']: 'কাল',
	['过去7天']: 'গত ৭ দিন',
	['过去10天']: 'গত ১০ দিন',
	['过去一个月']: 'গত এক মাস',
	['过去90天']: 'গত 90 দিন',
	['LOGO 预览']: 'LOGO প্রিভিউ',
	['档案格式：PNG、JPG，长宽不超过']: 'ফাইল ফরম্যাট: PNG, JPG, প্রস্থ ও উচ্চতা  এর বেশি নয়',
	['档案太大或格式不支援']: 'ফাইলটি খুব বড় বা রূপে সমর্থিত নয়',
	['且档案大小不得大于']: 'এবং ফাইলের আকার  বড় হওয়া উচিত নয়',
	['上传档案']: 'ফাইল আপলোড করুন',
	['新增IP白名单成功']: 'আইপি সাদা তালিকা সফলভাবে যোগ করা হয়েছে',
	['删除IP白名单成功']: 'আইপি সাদা তালিকা মুছে ফেলা হয়েছে সফলভাবে',
	['请输入欲查询的IP']: 'অনুগ্রহ করে অনুসন্ধান করতে চান এমন IP লিখুন',
	['请输入IP']: 'আইপি প্রবেশ করুন',
	['备注']: 'মন্তব্য',
	['备注不能为空']: 'মন্তব্য শূন্য হতে পারে না',
	['请输入备注']: 'দয়া করে মন্তব্য লিখুন',
	['新增时间']: 'নতুন সময়',
	['操作']: 'অপারেশন',
	['IP白名单']: 'IP শ্বেতপত্র',
	['新增IP']: 'নতুন আইপি',
	['新增IP白名单']: 'IP হোস্টনাম যুক্ত করুন',
	['确定删除此IP?']: 'এই আইপি মুছতে নিশ্চিত?',
	['平台']: 'প্ল্যাটফর্ম',
	['团队']: 'দল',
	['全体']: 'সর্বমোট',
	['客服']: 'গ্রাহক সেবা',
	['客服系统']: 'কাস্টমার সার্ভিস সিস্টেম',
	['个人帐号设定']: 'ব্যক্তিগত অ্যাকাউন্ট সেটিং',
	['最少6码']: 'ন্যূন্যতম 6 গজ',
	['最多20码']: 'সর্বাধিক ২০ গজ',
	['不能有空白']: 'খালি হতে পারবে না',
	['应至少包含1个英文和数字']: 'দিতে হবে অন্তত 1টি ইংরেজি এবং সংখ্যা',
	['公司名称']: 'কোম্পানির নাম',
	['僅能输入英文和数字']: 'শুধুমাত্র ইংরেজি এবং সংখ্যা প্রবেশ করতে পারবেন',
	['应至少包含1个英文']: 'একটি ইংরেজি অন্তত অন্তর্ভুক্ত করতে হবে',
	['最少5码']: 'সর্বনিম্ন 5 গজ',
	['IP不能为空']: 'IP শূন্য হতে পারে না',
	['非IP位址']: '非IP地址',
	['最多500个字']: 'সর্বাধিক 500টি শব্দ',
	['启用']: 'সক্রিয় করুন',
	['禁用']: 'নিষিদ্ধ',
	['对话量']: 'কথোপকথনের পরিমাণ',
	['目前客户数']: 'বর্তমান গ্রাহক সংখ্যা',
	['目前客服数']: 'বর্তমান গ্রাহক সেবা সংখ্যা',
	['接通对话量']: 'সংলাপ পরিমাণ',
	['全部']: 'সবकुछ',
	['最近一天']: 'শেষ দিনে',
	['最近一周']: 'গত সপ্তাহ',
	['最近一月']: 'সাম্প্রতিক একটি মাস',
	['新增过滤器']: 'নতুন ফিল্টার যোগ করুন',
	['请输入模組名称']: 'মডিউল নাম প্রবEnter করুন',
	['储存过滤模組']: 'সংগ্রহ ফিল্টার মডিউল',
	['读取过滤模組']: 'পড়া ফিল্টার মডিউল',
	['确定要删除模組']: 'মডিউল মুছে ফেলতে নিশ্চিত?',
	['分钟']: 'মিনিট',
	['接通时间']: 'যোগাযোগের সময়',
	['通话时间']: 'আলাপের সময়',
	['请选择或输入时间']: 'সময় নির্বাচন করুন বা প্রবেশ করুন',
	['等待时间']: 'অপেক্ষার সময়',
	['对话搜寻']: 'সংলাপ অনুসন্ধান',
	['请输入对话']: 'অনুগ্রহ করে সংলাপ করুন',
	['客戶 ID']: 'গ্রাহক আইডি',
	['请输入客戶ID']: 'দয়া করে গ্রাহক আইডি প্রবেশ করুন',
	['对话浏览模式']: 'কথোপকথনের ব্রাউজ মোড',
	['筆']: 'কলম',
	['客服本名']: 'গ্রাহক সেবা আসল নাম',
	['进入时间']: 'প্রবিধান সময়',
	['客服昵称']: 'গ্রাহক সেবা নাম',
	['客服系统管理端']: 'গ্রাহক সেবা সিস্টেম পরিচালনা প্যানেল',
	['数量']: 'পরিমাণ',
	['尚未上传档案']: 'ফাইল এখনও আপলোড করা হয়নি',
	['输入文字']: 'প্রবেশ করান লেখা',
	['请在此输入文字']: 'দয়া করে এখানে পাঠ্য প্রবেশ করান',
	['添加项目']: 'আইটেম যোগ করুন',
	['请选择']: 'অনুগ্রহ করে বেছে নিন',
	['新增文字']: 'নতুন লেখা',
	['新增档案']: 'নতুন ফাইল',
	['選項']: 'বিকল্প',
	['勾选标题']: 'শিরোনাম চেক করুন',
	['文字內容不能为空']: 'লেখা শূন্য হতে পারে না',
	['添加']: 'যোগ করুন',
	['上传标题']: 'আপলোড শিরোনাম',
	['单选标题']: 'একক নির্বাচক শিরোনাম',
	['输入框标题']: 'এন্ট্রি বক্স শিরোনাম',
	['请输入']: 'দয়া করে প্রবেশ করুন',
	['输入框']: 'ইনপুট বক্স',
	['单选']: 'একক নির্বাচনী',
	['核取方块']: 'নির্বাচন বক্স',
	['请选择一个标签']: 'একটি লেবেল নির্বাচন করুন',
	['确定要删除此项目和其所有子项目？']: 'এই আইটেম এবং এর সমস্ত সাবআইটেম মুছে ফেলতে নিশ্চিত?',
	['答案']: 'উত্তর',
	['表单']: 'ফর্ম',
	['清除此阶层设定']: 'এই স্তরের সেটিং মুছে ফেলুন',
	['请输入此阶层问题']: 'দয়া করে এই স্তরের প্রশ্নটি প্রবেশ করান',
	['新增选项']: 'নতুন বিকল্প',
	['新增表单']: 'নতুন ফর্ম',
	['新增答案']: 'নতুন উত্তর',
	['新增充值表单']: 'নতুন রিচার্জ ফর্ম',
	['若切换种类后, 将清除原有的和其子项目资料']: 'যদি প্রকার পরিবর্তন করা হয়, তবে পূর্বে বিদ্যমান এবং এর উপ-স্কুলের তথ্য মুছে ফেলা হবে।',
	['确定要清除所有资料和其子项目资料？']: 'আপনি কি সত্যিই সমস্ত তথ্য এবং এর উপ-অবজেক্টের তথ্য মুছতে চান?',
	['阶层']: 'শ্রেণী',
	['开场语']: 'শুভেচ্ছা',
	['开场语不能为空']: 'প্রারম্ভিকা খালি থাকতে পারে না',
	['结尾感谢语']: 'শেষ ধন্যবাদ',
	['结尾感谢语不能为空']: 'শেষ ধন্যবাদ বার্তা শূন্য থাকতে পারে না',
	['发布']: 'প্রকাশ',
	['复制']: 'কপি',
	['选择目的平台']: 'গন্তব্য প্ল্যাটফর্ম নির্বাচন করুন',
	['确定复制到']: 'নিশ্চিত কপি করতে',
	['是否要正式发布到使用环境？']: 'এটি কি ব্যবহার পরিবেশে আনুষ্ঠানিকভাবে প্রকাশ করা উচিত?',
	['储存版本']: 'সংরক্ষণ সংস্করণ',
	['版本名称']: 'সংস্করণ নাম',
	['请输入版本名称']: 'সংস্করণ নাম লিখুন',
	['确定是否储存此版本']: 'এই সংস্করণটি সংরক্ষণ করা হবে কিনা নিশ্চিত করুন',
	['版本储存成功']: 'সংস্করণ সংরক্ষণ সফল',
	['最多10个字']: 'সর্বাধিক 10টি অক্ষর',
	['公告一']: 'ঘোষণা এক',
	['公告二']: 'বিজ্ঞপ্তি দুই',
	['公告三']: 'ঘোষণা তিন',
	['公告储存成功']: 'সংবাদ সংরক্ষণ সফল',
	['标题']: 'শিরোনাম',
	['內文']: 'পাঠ্য',
	['修改登入密码']: 'লগইন পাসওয়ার্ড পরিবর্তন',
	['修改基本资讯']: 'মৌলিক তথ্য সংশোধন করুন',
	['昵称']: 'ডাকনাম',
	['昵称不能为空']: 'নিকনাম শুন্য হতে পারে না',
	['请输入昵称']: 'বাংলা নাম লিখুন',
	['本名']: 'মূল নাম',
	['本名不能为空']: 'বাঁশি নাম খালি থাকতে পারে না',
	['请输入本名']: 'অনুগ্রহ করে আপনার আসল নাম লিখুন',
	['选择图像']: 'ছবি নির্বাচন করুন',
	['状态']: 'অবস্থা',
	['平台代码']: 'প্ল্যাটফর্ম কোড',
	['平台代码不能为空']: 'প্ল্যাটফর্ম কোড শূন্য হতে পারে না',
	['使用ID模式登入']: 'আইডি মোডে লগ ইন করুন',
	['新增平台']: 'নতুন প্ল্যাটফর্ম',
	['修改平台']: 'পরিবর্তন প্ল্যাটফর্ম',
	['确定重新产生Key/IV?']: 'কী/আইভি পুনঃউৎপন্ন করতে নিশ্চিত?',
	['进入公司成功']: 'কোম্পানিতে প্রবেশ সফল',
	['确定禁用公司?']: 'কোম্পানি নিষ্কрий করার নিশ্চয়তা?',
	['确定启用公司?']: 'কোম্পানি সক্রিয় করতে নিশ্চিত?',
	['修改公司']: 'কোম্পানি সংশোধন',
	['进入公司']: 'কোম্পানিতে প্রবেশ',
	['确定进入公司?']: 'কোম্পানিতে প্রবেশ নিশ্চিত?',
	['新增标签']: 'নতুন ট্যাগ যোগ করুন',
	['代号']: 'কোড নাম',
	['代号不可为空']: 'কোড শূন্য হতে পারে না',
	['名称']: 'নাম',
	['名称不可为空']: 'নাম খালি হতে পারে না',
	['颜色']: 'রঙ',
	['颜色不可为空']: 'রঙ খালি হতে পারে না',
	['进入标签']: 'ট্যাগে প্রবেশ করুন',
	['修改标签']: 'মোডিফাই লেবেল',
	['确定开启进入标签?']: 'নিশ্চিতভাবে ট্যাবটি খোলার জন্য প্রবেশ করতে চান?',
	['确定关闭进入标签?']: 'প্রবেশ ট্যাব বন্ধ করতে নিশ্চিত?',
	['确定删除此标签?']: 'সত্যিই কি এই ট্যাগটি মুছে ফেলা হবে?',
	['标签创建成功']: 'লেবেল তৈরি সফল',
	['标签更新成功']: 'লেবেল আপডেট সফল',
	['进入标签更新成功']: 'লেবেল আপডেট সফলভাবে প্রবেশ করুন',
	['标签删除成功']: 'লেবেল মুছে ফেলা হয়েছে',
	['请输入代号、名称等关键字']: 'দয়া করে কোড, নাম ইত্যাদির মতো মূলশব্দ লিখুন',
	['设定开场白成功']: 'প্রাথমিক বক্তব্য সেটিং সফল',
	['客戶进入开场白']: 'গ্রাহক প্রারম্ভিক সংলাপে প্রবেশ করে',
	['客戶进入开场白不可为空']: 'গ্রাহকের প্রারম্ভিক বক্তব্য ফাঁকা হতে পারে না',
	['第一次通知时间']: 'প্রথম নোটিশের সময়',
	['第{{count}}次通知时间']: 'অবশেষে{{count}}তম নোটিশের সময়',
	['设置错误']: 'ত্রুটি সেটিং',
	['设定等待过长通知时间成功']: 'সফলভাবে অপেক্ষার সময় নির্ধারণ করা হয়েছে',
	['秒']: 'দ্বিতীয়',
	['对话自动断开时间']: 'সংলাপ স্বয়ংক্রিয়ভাবে বিচ্ছিন্ন হওয়ার সময়',
	['未发话时间']: 'মৌনকাল',
	['未发话提示文字']: 'অনুরোধ করা বাণী',
	['设定对话断开成功']: 'কথোপকথনের সংযোগ বিচ্ছিন্ন সফলভাবে',
	['Favicon预览']: 'ফেভিকন প্রিভিউ',
	['更换 Favicon 成功']: 'Favicon পরিবর্তন সফল',
	['档案格式：ICO，長寬不超過 32x32 px']: 'ফাইলের ফরম্যাট: ICO, প্রস্থ এবং উচ্চতা 32x32 পিক্সেলের বেশি নয়',
	['更换 LOGO 成功']: 'LOGO সফলভাবে পরিবর্তন করা হয়েছে',
	['智能客服']: 'স্মার্ট কাস্টমার সার্ভিস',
	['设定通道成功']: 'চ্যানেল সফলভাবে সেট আপ করা হয়েছে',
	['设定提示音效成功']: 'সাফল্যের সাথে এলার্ম সাউন্ড সেট করা হয়েছে',
	['单音']: 'এককশব্দ',
	['循环音']: 'সাইকেল সাউন্ড',
	['编号']: 'সংখ্যা',
	['资料类型']: 'তথ্য প্রকার',
	['资料类型不可为空']: 'তথ্য ধরনের ক্ষেত্র খালি থাকতে পারে না',
	['数字']: 'সংখ্যা',
	['字串']: 'স্ট্রিং',
	['布林']: 'ব্রাইল',
	['建立标签成功']: 'লেবেল সফলভাবে তৈরি হয়েছে',
	['修改标签成功']: 'লেবেল সফলভাবে পরিবর্তিত হয়েছে',
	['删除标签成功']: 'লেবেল মুছে ফেলা হয়েছে সফলভাবে',
	['更换 LOGO']: 'লোগো পরিবর্তন',
	['更换 Favicon']: 'ফেভিকন পরিবর্তন করা',
	['对话断开']: 'আলাপ বিচ্ছিন্ন',
	['等待过长通知时间']: 'অতিদীর্ঘ বিজ্ঞপ্তির সময় অপেক্ষা',
	['开场白']: 'উপস্থাপন',
	['提示音效设定']: 'নোটিফিকেশন সাউন্ড সেটিং',
	['通道设定']: 'পথ সেটিং',
	['自定义标签']: 'নিজস্ব ট্যাগ',
	['开启维修模式将会停止客服系统运作。确定要开启嗎？']: 'সংরক্ষণ মোড চালু করা হলে গ্রাহক সেবা সিস্টেমের কার্যক্রম বন্ধ হয়ে যাবে। আপনি কি সত্যিই চালু করতে চান?',
	['关闭维修模式，客服系统将会继续运作。确定要关闭嗎？']: 'মেরামত মোড বন্ধ করুন, গ্রাহক সিস্টেম চালানোর জন্য চলতে থাকবে। আপনি বন্ধ করতে চান কি?',
	['状态更新成功']: 'অবস্থা আপডেট সফল',
	['通知讯息更新成功']: 'সংবাদ বার্তা সফলভাবে হালনাগাদ হয়েছে',
	['维修模式']: 'মেরামত মোড',
	['通知讯息设定']: 'সংবাদ বার্তা সেটিং',
	['尚未连线状态']: 'সংযোগ স্থাপিত হয়নি',
	['尚未连线状态描述']: 'সংযোগের অবস্থার বর্ণনা হয়নি',
	['已连线状态']: 'সংযুক্ত স্থিতি',
	['已连线状态描述']: 'সংযোগ স্থাপিত অবস্থার বর্ণনা',
	['开启成功']: 'সফলতা শুরু',
	['关闭成功']: 'সফলভাবে বন্ধ',
	['关闭登入管理模式将会限制客戶藉由输入ID 进入客服，确定要关闭嗎？(若沒有提供客戶Profile资料则会进入错误页面)']: 'লগইন ম্যানেজমেন্ট মোড বন্ধ করা হলে গ্রাহকদের আইডি প্রবেশ করে客服তে প্রবেশ করতে সম限制িত হবে, আপনি কি বন্ধ করতে চান? (যদি গ্রাহকের প্রোফাইল তথ্য প্রদান না করা হয় তবে এটি একটি ত্রুটি পৃষ্ঠায় প্রবাহিত হবে)',
	['开启登入管理模式将会開放客戶藉由输入 ID 进入客服，确定要开启嗎？']: 'লগইন ম্যানেজমেন্ট মোড খুললে গ্রাহকরা আইডি দিয়ে গ্রাহক সেবায় প্রবেশ করতে পারবে, কি আপনি এটি চালু করতে চান?',
	['请输入帐号、昵称、角色等关键字']: 'একাউন্ট, ডাকনাম, ভূমিকা ইত্যাদি কীওয়ার্ড প্রবেশ করুন',
	['新增角色']: 'নতুন চরিত্র',
	['修改角色']: 'পাত্র পরিবর্তন',
	['角色创建成功']: 'পাত্র চরিত্র তৈরি সফল',
	['角色更新成功']: 'পাত্রের আপডেট সফল',
	['角色删除成功']: 'পাত্র অপসারণ সফল',
	['请输入角色名称，平台，权限等关键字']: 'অভিনেতার নাম, প্ল্যাটফর্ম, অনুমতি ইত্যাদি কিওয়ার্ড প্রবেশ করুন',
	['关键字']: 'কীওয়ার্ড',
	['角色名称']: 'কির্তি নাম',
	['角色名称不可为空']: 'পাত্রের নাম শূন্য হতে পারবে না',
	['请输入角色名称']: 'অনুগ্রহ করে চরিত্রের নাম লিখুন',
	['上级角色']: 'উপরে থাকা ভূমিকা',
	['上级角色不可为空']: 'পর্যাপ্ত ভূমিকা খালি থাকতে পারবে না',
	['权限']: 'অধিকার',
	['确定删除此角色?']: 'এই চরিত্রটি মুছে ফেলা নিশ্চিত?',
	['图像不能为空']: 'ছবি খালি থাকতে পারবে না',
	['新增团队']: 'নতুন দল',
	['修改团队']: 'সংস্কার দল',
	['团队创建成功']: 'দল তৈরি সফল',
	['团队修改成功']: 'দল পরিবর্তন সফল',
	['团队删除成功']: 'দলটি সফলভাবে অপসারণ করা হয়েছে',
	['人数']: 'মানুষের সংখ্যা',
	['新登入密码']: 'নতুন লগইন পাসওয়ার্ড',
	['新密码不能设定與舊密码相同']: 'নতুন পাসওয়ার্ড পুরানো পাসওয়ার্ডের মতো হতে পারবে না।',
	['新密码與確認密码不相同']: 'নতুন পাসওয়ার্ড এবং নিশ্চিতকরণ পাসওয়ার্ড একই নয়',
	['确定修改登入密码?']: 'এখন কি লগইন পাসওয়ার্ড পরিবর্তনের বিষয়টি নিশ্চিত করবেন?',
	['登入密码修改成功，请重新登入']: 'লগইন পাসওয়ার্ড সফলভাবে পরিবর্তন হয়েছে, দয়া করে আবার লগইন করুন',
	['个人资讯']: 'ব্যক্তিগত তথ্য',
	['搜寻快捷语']: 'সংক্ষিপ্ত শব্দগুলো খোঁজা',
	['登出']: 'লগ আউট',
	['帐密错误']: 'একাউন্ট পাসওয়ার্ড ভুল',
	['一']: 'এক',
	['二']: 'দুই',
	['三']: 'তিন',
	['四']: 'চার',
	['五']: 'পাঁচ',
	['六']: 'ছয়',
	['七']: 'সাত',
	['请输入客服本名、客服昵称等关键字']: 'দয়া করে গ্রাহক সেবার আসল নাম, গ্রাহক সেবার ডাকনাম ইত্যাদি কীওয়ার্ড প্রবেশ করুন',
	['共 {{count}} 筆资料']: 'মোট {{count}} টি তথ্য',
	['平台语言不能为空']: 'প্ল্যাটফর্মের ভাষা শূন্য হতে পারে না',
	['开启']: 'খোলা',
	['语言']: 'ভাষা',
	['切换语言']: 'ভাষা পরিবর্তন করুন',
	['语言名称']: 'বাংলা ভাষা',
	['系统设定']: 'সিস্টেম সেটিং',
	['储存成功']: 'সংরক্ষণ সফল',
	['发布成功']: 'প্রকাশ সফল',
	['复制成功']: 'সংগ্রহ সফল',
	['项目选取']: 'প্রকল্প নির্বাচন',
	['图像']: 'ছবি',
	['角色']: 'চরিত্র',
	['新增帐号']: 'নতুন অ্যাকাউন্ট',
	['角色不能为空']: 'ভূমিকা খালি থাকতে পারবে না',
	['登入密码']: 'লগইন পাসওয়ার্ড',
	['请输入代号、名称、备注等关键字']: 'দয়া করে কোড, নাম, মন্তব্য ইত্যাদি কীওয়ার্ড প্রবেশ করুন',
	['确定删除此团队?']: 'এই দলটি মুছে ফেলা নিশ্চিত?',
	['切换语言成功']: 'ভাষা পরিবর্তন সফল হয়েছে',
	['确定要切换语言?']: 'ভাষা পরিবর্তন করতে চান নিশ্চিত?',
	['选项']: 'বিকল্প',
	['选择语言']: 'ভাষা নির্বাচন',
	['修改成功']: 'সফলভাবে সংশোধন',
	['舊登入密码']: 'পুরনো লগইন পাসওয়ার্ড',
	['確認新登入密码']: 'নতুন লগইন পাসওয়ার্ড নিশ্চিত করুন',
	['语言切换成功，將重整页面以套用更新']: 'ভাষা পরিবর্তন সফল হয়েছে, আপডেট প্রয়োগ করতে পৃষ্ঠাটি পুনরায় লোড করা হবে।',
	['笔 / 页']: 'লেখনি / পৃষ্ঠা',
	['时段搜寻']: 'সময় অনুসন্ধান',
	['请选择时段']: 'সময় নির্বাচন করুন',
	['更换背景色']: 'পটভূমির রঙ পরিবর্তন করুন',
	['设定背景颜色成功']: 'পটভূমির রং সফলভাবে সেট করা হয়েছে',
	['请重新登入']: 'দয়া করে আবার লগ ইন করুন',
	['绑定谷歌验证']: 'গুগল নিশ্চিতকরণ বেঁধে দিন',
	['解除绑定']: 'বন্ধন মুক্ত করা',
	['谷歌验证状态']: 'গুগল যাচাইকরণ স্টেটাস',
	['已绑定']: 'বাঁধা হয়েছে',
	['未绑定']: 'অবঢন্ত',
	['解绑谷歌验证失败']: 'Google प्रमाणीकरण अनबाइंड करना विफल रहा',
	['二维码方式添加']: 'কিউআর কোডের মাধ্যমে যোগ করুন',
	['请在 Google 身份验证器中采用添加条形码方式添加']: 'দয়া করে Google প্রমাণক এ বারকোড যোগ করার মাধ্যমে যোগ করুন।',
	['密钥方式添加']: 'কী পদ্ধতি যোগ করুন',
	['请在 Google 身份验证器中采用输入提供的密钥方式添加']: 'দয়া করে প্রদত্ত কী পদ্ধতি ব্যবহার করে গুগল প্রমাণীকরণকারী এ যোগ করুন।',
	['密钥如下所示']: 'কী নীচে প্রদর্শিত হয়েছে',
	['请再次输入登入密码']: 'দয়া করে আবার লগইন পাসওয়ার্ড লিখুন',
	['谷歌6位动态密码']: 'গুগল ৬ অঙ্কের ডায়নামিক পাসওয়ার্ড',
	['请绑定谷歌验证']: 'দয়া করে গুগল ভেরিফিকেশন বাঁধুন',
	['谷歌验证绑定成功']: 'গুগল যাচাইকরণ সফলভাবে সংযুক্ত হয়েছে',
	['解绑谷歌验证成功']: 'গুগল যাচাইকরণ আবদ্ধ解除 সফল',
	['确定解绑谷歌验证？']: 'গুগল প্রমাণীকরণ বন্ধ করার জন্য নিশ্চিত?',
	['请输入谷歌动态码']: 'গুগল ডাইনামিক কোড প্রবেশ করুন',
	['谷歌动态码']: 'গুগল ডাইনামিক কোড',
	['谷歌动态码不能为空']: 'গুগল ডাইনামিক কোড শূন্য হতে পারবে না',
	['谷歌动态码长度6码']: 'গুগল ডাইনামিক কোডের দৈর্ঘ্য 6 কোড',
	['谷歌动态码错误']: 'গুগল ডায়নামিক কোড ভুল',
	['內容']: '内容',
	['搜寻']: 'অনুসন্ধান',
	['连线中断，点击“确定”即重新连线客服。']: 'সংযোগ বিচ্ছিন্ন হয়েছে, ‘ঠিক আছে’ ক্লিক করলে কাস্টমার সাপোর্টের সাথে পুনরায় সংযোগ হবে।',
	['充值表单']: 'রিচার্জ ফর্ম',
	['网银充值']: 'ইন্টারনেট ব্যাংকিং রিচার্জ',
	['扫码充值']: 'স্ক্যান করে রিচার্জ করুন',
	['带入目前帐号']: 'বর্তমান অ্যাকাউন্টে নিয়ে আসুন',
	['自行输入平台帐号']: 'স্বতঃস্ফূর্তভাবে প্ল্যাটফর্ম অ্যাকাউন্ট প্রবেশ করুন',
	['充值方式']: 'রিচার্জ পদ্ধতি',
	['平台帐号']: 'প্ল্যাটফর্ম অ্যাকাউন্ট',
	['充值金额']: 'রিচার্জের পরিমাণ',
	['付款人姓名']: 'পেমেন্টকারী নাম',
	['确认语']: 'নিশ্চিতকরণ ',
	['操作时间']: 'অপারেশন সময়',
	['操作者']: 'অপেরেটর',
	['请输入备注等关键字']: 'অনুগ্রহ করে মন্তব্য ইত্যাদি কীশব্দ প্রবেশ করুন',
	['操作类型']: 'কার্যক্রমের ধরন',
	['修改平台昵称']: 'মঞ্চের নাম পরিবর্তন করুন',
	['修改平台昵称成功']: 'প্ল্যাটফর্মের ডাকনাম সফলভাবে পরিবর্তন করা হয়েছে',
	['输入格式错误']: ' ইনপুট ফরম্যাট ত্রুটি',
	['套用']: 'প্রয়োগ',
	['确定套用到']: 'নিশ্চিত প্রয়োগ করা',
	['套用成功']: 'সাফল্যের সাথে প্রয়োগ করা হয়েছে',
	['储存方式']: 'সংরক্ষণ পদ্ধতি',
	['储存時間']: 'সংগ্রহের সময়',
	['系统发布']: 'সিস্টেম প্রকাশ',
	['手动储存']: 'ম্যানুয়াল সঞ্চয়',
	['自动储存']: 'অটো সঞ্চয়',
	['预览']: 'পূর্বদর্শন',
	['最多350个字']: 'সর্বাধিক ৩৫০টি শব্দ',
	['修改']: 'সংশোধন',
	['共同资讯管理']: 'কমন তথ্য ব্যবস্থাপনা',
	['共同资讯创建成功']: 'সাম্প্রদায়িক তথ্য অসাধারণভাবে তৈরি হয়েছে',
	['共同资讯修改成功']: 'সाझা তথ্য সম্পাদনা সফল',
	['新增共同资讯']: 'নতুন সহযোগী তথ্য',
	['修改共同资讯']: 'মৈত্রী তথ্য সংশোধন',
	['删除成功']: 'মুছে ফেলা সফল',
	['已设置于其他答案，无法删除']: 'অন্যান্য উত্তরে সেট করা হয়েছে, মুছে ফেলা যাবে না',
	['请输入名称、内容等关键字']: 'অনুগ্রহ করে নাম, বিষয়বস্তু ইত্যাদির কীওয়ার্ড প্রবেশ করুন',
	['确定删除此共同资讯？']: 'এই যৌথ তথ্য মুছে ফেলা নিশ্চিত করবেন?',
	['共同资讯']: 'সाझা তথ্য',
	['尚未选择共同资讯']: 'এখনো একসাথে তথ্য বাছাই করা হয়নি',
	['选择共同资讯']: 'মিলিত তথ্য বেছে নিন',
	['选择']: 'নির্বাচন',
	['点击「确定」后，即覆盖该平台的快捷语设定']: '"নিশ্চিত" এ ক্লিক করার পর, এই প্ল্যাটফর্মের শর্টকাট ভাষা সেটিংগুলি গ্রহণ করা হবে।',
	['已复制：目的平台']: 'লক্ষ্য প্ল্যাটফর্ম',
	['是否离开客服系统？']: 'আপনি কি কাস্টমার সাপোর্ট সিস্টেম থেকে বের হচ্ছেন?',
	['感谢您的作答，此次评分为：{{score}}分']: 'আপনার উত্তরের জন্য ধন্যবাদ, এই পরিষেবার রেটিং: {{score}} স্টার',
	['共 {{count}} 筆']: 'মোট {{count}} টি',
	['分']: 'ভাগ',
	['新增公司']: 'নতুন কোম্পানি',
	['翻译']: 'অনুবাদ',
	['显示原文']: 'মূল পাঠ্য দেখান',
	['解绑谷歌验证']: 'গুগল ভেরিফিকেশন মুক্ত করুন',
	['请输入名称 内容等关键字']: 'নাম, বিষয়বস্তু ইত্যাদি কী শব্দ লিখুন',
	['表单选项']: 'ফর্মের বিকল্প',
	['年']: 'বছর',
	['等待时间颜色设定']: 'অপেক্ষার সময়ের রং সেটিং',
	['显示颜色']: 'রং প্রদর্শন',
	['确认删除此规则?']: 'এই নিয়মটি মুছে ফেলার বিষয়টি নিশ্চিত করবেন কি?',
	['页签']: 'ট্যাব',
	['超过 {{time}} 分钟']: 'অবর্তী {{time}} মিনিট',
	['新增成功']: 'সফলভাবে যুক্ত হয়েছে',
	['删除完成']: 'যা ডিলিট করা হয়েছে',
	['等待时间(分钟)']: 'অপেক্ষার সময় (মিনিট)',
	['时间']: 'সময়',
	['不可为空']: 'শূন্য হতে পারবেনা',
	['需为正整数']: 'যথার্থ ধনাত্মক পূর্ণসংখ্যা হতে হবে',
	['按平台名称排列(A-Z)']: 'প্ল্যাটফর্মের নাম অনুযায়ী সাজান (A-Z)',
	['按平台名称排列(Z-A)']: 'প্ল্যাটফর্মের নাম অনুযায়ী সাজান (Z-A)',
	['旧版面模式']: 'পুরনো ফরম্যাট',
	['自动翻译']: 'স্বয়ংক্রিয় অনুবাদ',
	['功能設定']: 'ফাংশন সেটিং',
	['确认切换版面？']: 'মাঠ পরিবর্তন নিশ্চিত করবেন?',
	['确认开启自动翻译？']: 'অব자동 翻译টি নিশ্চিত করবেন?',
	['确认关闭自动翻译？']: 'স্বয়ংক্রিয় অনুবাদ বন্ধ করতে নিশ্চিত?',
	['原文']: 'মূল',
	['泰语']: 'থাই ভাষা',
	['追踪']: 'অনুসরণ',
	['取消追踪']: 'অনুসরণ বন্ধ করুন',
	['预览影片']: 'ভিডিও প্রিভিউ',
	['仅能上传 MP4、MOV、 JPEG (JPG)、PNG、 GIF、HEIC、RAW、HEIF档案']: 'কোভার কেবল MP4, MOV, JPEG (JPG), PNG, GIF, HEIC, RAW, HEIF ফাইল আপলোড করতে পারবেন',
	['请勿输入语法相关字串']: 'দয়া করে সিনট্যাক্স সংক্রান্ত স্ট্রিং ইনপুট করবেন না',
	['输入名称']: 'ইনপুট নাম',
	['设为预设版本']: 'ডিফল্ট সংস্করণ হিসেবে সেট করুন',
	['另存为新版本']: 'নতুন সংস্করণ হিসাবে সংরক্ষণ করুন',
	['请选择版本']: 'দয়া করে সংস্করণ নির্বাচন করুন',
	['一键开关']: 'একক বোতাম',
	['若有服务中的客户，无法关闭服务平台与切换版本']: 'যদি সেবায় গ্রাহক থাকে, তাহলে সেবা প্ল্যাটফর্ম বন্ধ করা এবং সংস্করণ পরিবর্তন করা যাবে না।',
	['是否确认要覆盖已有的设定，储存新的设定？']: 'আপনি কি নিশ্চিত যে আপনি বিদ্যমান সেটিংগুলি অতিক্রম করতে চান, নতুন সেটিংগুলি সংরক্ষণ করতে চান?',
	['已储存超过五个版本']: '৫টির বেশি সংস্করণ সংরক্ষণ করা হয়েছে',
	['版本已变动，是否需要储存？']: 'সংস্করণ পরিবর্তিত হয়েছে, সংরক্ষণ প্রয়োজন কি?',
	['确定删除此版本？']: 'এই সংস্করণটি মুছে ফেলতে নিশ্চিত?',
	['编辑版本']: 'সম্পাদনা সংস্করণ',
	['侦测到重复联系客服系统，若非您本人请告知客服']: 'গ্রাহক সেবা সিস্টেমে পুনরাবৃত্তি শনাক্ত করা হয়েছে। যদি এটি আপনি না হয়ে থাকেন, অনুগ্রহ করে গ্রাহক সেবাকে জানান।',
	['删除此版本']: 'এ সংস্করণটি মুছুন',
	['刪除成功']: 'মুছে ফেলা হয়েছে সফলভাবে',
	['刪除失敗']: 'মুছে ফেলা ব্যর্থ',
	['儲存成功']: 'সফলভাবে সংরক্ষণ করা হয়েছে',
	['儲存失敗']: 'সংরক্ষণ ব্যর্থ',
	['您好，请问要选择哪个问题？']: 'হ্যালো, আপনি কোন বিষয়টি জানতে চান?',
	['等待服务区']: 'সেবা অঞ্চল অপেক্ষা',
	['按时间排列(長到短)']: 'সময়ের ভিত্তিতে সাজানোর (দীর্ঘ থেকে সংক্ষিপ্ত)',
	['按时间排列(短到長)']: 'সাময়ের ভিত্তিতে সাজানো (ছোট থেকে বড়)',
	['亲, 欢迎您的到来～很高兴为您服务，请先别著急，我们即将为您提供服务 ...']: 'প্রিয় গ্রাহক, স্বাগতম! আপনাকে সেবা দিতে পেরে আমরা আনন্দিত, দয়া করে অপেক্ষা করুন...',
	['编辑标签']: 'সম্পাদকীয় লেবেল',
	['于 {{time}} 侦测到会员【稍早已离线】']: '{{time}} এ সদস্য【কিছুক্ষণ আগে অফলাইন】 শনাক্ত করা হয়েছে',
	['{{score}}分']: '{{score}} পয়েন্ট',
	['未评分']: 'অবশ্যই নয়',
	['客服完成']: 'গ্রাহকসেবা সম্পন্ন',
	['会员离线']: 'সদস্য অফলাইন',
	['超时自动断线']: 'অতিরিক্ত সময়ে স্বয়ংক্রিয়ভাবে ডিসকানেক্ট',
	['{{text}}不可重复']: '{{text}} পুনরাবৃত্তি করা যাবে না',
	['{{text}}不能为空']: '{{text}} খালি হতে পারে না',
	['{{text}}设置错误']: '{{text}} ত্রুটি সেটিং',
	['平均通话时长']: 'গড় ফোনকাল দৈর্ঘ্য',
	['平均通话数']: 'গড় কল সংখ্যা',
	['请选择角色名称']: 'অভিনয়ের নাম নির্বাচন করুন',
	['请选择客服']: 'দয়া করে গ্রাহক সেবা নির্বাচন করুন',
	['请选择团队']: 'দলটি নির্বাচন করুন',
	['播放']: 'প্লে',
	['统计时间']: 'পরিসংখ্যানের সময়',
	['统计时间不可为空']: 'স্থাপন সময় খালি হতে পারে না',
	['请输入时间']: 'সময় লিখুন',
	['时间筛选']: 'সময় ফিল্টার',
	['汇出']: 'রপ্তানি',
	['未出勤']: 'অনুপস্থিত',
	['客服平均通话时长']: 'গ্রাহক সেবা গড় যোগাযোগের সময়',
	['数量筛选']: 'সংখ্যা ফিল্টার',
	['客服平均等待时间']: 'গ্রাহক পরিষেবা গড় অপেক্ষার সময়',
	['上一个月']: 'গত মাস',
	['导出Excel成功']: 'এক্সেল সফলভাবে রপ্তানী করা হয়েছে',
	['对话结束']: 'চ্যাট শেষ',
	['满意度/客服']: 'সন্তুষ্টি/গ্রাহক পরিষেবা',
	['日期/客服']: 'তারিখ/সেবা কেন্দ্র',
	['总数']: 'মোট',
	['日平均']: 'দৈনিক গড়',
	['客服日均量']: 'গ্রাহক সেবা দৈনিক পরিমাণ',
	['客服通话总量']: 'গ্রাহক সেবার কল মোট সংখ্যা',
	['日总量']: 'দিনের মোট পরিমাণ',
	['请输入数量']: 'সংখ্যা লিখুন',
	['满意度预设分数']: 'সন্তুষ্টির পূর্বনির্ধারিত স্কোর',
	['当会员未评分，会自动给予此预设分数。']: 'যখন সদস্য মূল্যায়ন করেননি, তখন স্বয়ংক্রিয়ভাবে এই পূর্বনির্ধারিত স্কোর দেওয়া হবে।',
	['设定满意度预设分数成功']: 'সন্তোষের পূর্বনির্ধারিত স্কোর সফলভাবে সেট করা হয়েছে',
	['客户满意度管理']: 'গ্রাহক সন্তুষ্টি ব্যবস্থাপনা',
	['对话结束方式']: 'সংলাপ শেষ করার উপায়',
	['对话满意度']: 'বক্তৃতার সন্তোষজনকতা',
	['时段']: 'সময়কাল',
	['客服平均满意度']: 'কাস্টমার সেবার গড় সন্তুষ্টি',
	['公用设定']: 'সাধারণ সেটিংস',
	['通话时长']: 'কলে সময়',
	['服务时段']: 'সেবা সময়',
	['储存时间']: 'সংরক্ষণ সময়',
	['客服不可为空']: 'গ্রাহক পরিষেবা শূন্য হতে পরবে না',
	['团队不可为空']: 'দল শূন্য হতে পারে না',
	['请输入对话内容关键字']: 'অনুগ্রহ করে কথোপকথনের বিষয়বস্তু কীওয়ার্ড প্রবেশ করুন।',
	['请输入客服本名、昵称或帐号']: 'দয়া করে গ্রাহক সেবার আসল নাম, ডাক নাম বা একাউন্ট লিখুন',
	['平台不可为空']: 'প্ল্যাটফর্ম খালি হতে পারে না',
	['线上']: 'অনলাইন',
	['离线']: 'অফলাইন',
	['日期不可为空']: 'তারিখ খালি থাকতে পারে না',
	['亲，跟您再次确认下，申请并进行此笔充值 {{chargeNumber}} 元的帐号是 {{chargeAccount}}，对吗？']: 'প্রিয়, আমি আবার নিশ্চিত করছি, এই রিচার্জের জন্য আবেদন এবং এটি সম্পন্ন করা {{chargeNumber}} টাকার অ্যাকাউন্ট হল {{chargeAccount}}, তাই না?',
	['您的等待顺位为第 {{pendingOrder}} 位']: 'আপনার অপেক্ষার সিরিয়াল নম্বর {{pendingOrder}}',
	['拒絕由 {{inviter}} 转接至 {{invitee}}']: '{{inviter}} থেকে {{invitee}} এ স্থানান্তর অস্বীকার।',
	['{{name}} 已于 {{time}} 关闭视窗']: '{{name}} {{time}} তে উইন্ডো বন্ধ করেছে',
	['{{name}} 已于 {{time}} 点选案件完成']: '{{name}} {{time}} টাতে মামলা সম্পন্ন হয়েছে',
	['{{name}} 已于 {{time}} 成功加入协作']: '{{name}} সফলভাবে {{time}} সহযোগিতায় যোগদান করেছে',
	['{{name}} 已于 {{time}} 离开协作']: '{{name}} {{time}} এ সহযোগিতা ছেড়ে গেছে',
	['{{name}} 已于 {{time}} 中断连线']: '{{name}} {{time}} এ সংযোগ বিচ্ছিন্ন হয়েছে',
	['英文']: 'ইংরেজি',
	['验证码设定']: 'ভেরিফিকেশন কোড সেটিং',
	['启用验证码']: 'ভেরিফিকেশন কোড সক্রিয় করুন',
	['设定验证码成功']: 'সফলভাবে নিরাপত্তা কোড সেট করা হয়েছে',
	['启用验证码功能后，客户需完成验证才能进入客服系统等待区。']: 'ভেরিফিকেশন কোডের ফিচারটি সক্রিয় করার পরে, গ্রাহককে গ্রাহক পরিষেবা সিস্টেমের অপেক্ষা অঞ্চলে প্রবেশ করতে যাচাই সম্পন্ন করতে হবে।',
	['禁止连续发话']: 'একটানা মেসেজ দেওয়া নিষেধ',
	['启用禁止连续发话']: 'পর্যায়ক্রমে কথোপকথন নিষ্ক্রিয় করুন',
	['当会员在「限制秒数」内发话超过设定的次数，系统将会自动跳警告。']: 'যখন সদস্য "সীমিত সেকেন্ড" এর মধ্যে নির্ধারিত次数 এর বেশি কথা বলেন, সিস্টেম স্বয়ংক্রিয়ভাবে সতর্কতা প্রদর্শন করবে।',
	['客户端限制于']: 'ক্লায়েন্ট সীমাবদ্ধ থাকে',
	['发话次数达到']: 'মৌখিক মন্তব্যের পরিমাণ পৌঁছেছে',
	['次']: 'বার',
	['暂时无法发话']: 'অস্থায়ীভাবে কথা বলতে পারছি না',
	['储存完成']: 'সংগ্রহ সম্পন্ন',
	['发送消息过于频繁 可稍后再试']: 'শুভ বার্তা খুব ঘন ঘন পাঠানো হয়েছে, পরে আবার চেষ্টা করুন',
	['IP黑名单管理']: 'আইপি কালোতালিকা পরিচালনা',
	['共 {{total}} 笔']: 'মোট {{total}} টি',
	['第 {{min}} - {{max}} 笔/共 {{total}} 笔']: '第 {{min}} - {{max}} পেন/মোট {{total}} পেন',
	['顯示']: 'প্রদর্শন',
	['查询IP黑名单']: 'আইপি ব্ল্যাকলিস্ট অনুসন্ধান',
	['设定自动添加黑名单']: 'স্বয়ংক্রিয়ভাবে ব্ল্যাকলিস্ট যোগ করার সেটিং',
	['白名單管理']: 'শ্বেতপত্র ব্যবস্থাপনা',
	['解除时间']: 'মুক্তি সময়',
	['永久封锁']: 'স্থায়ী ব্লক',
	['新增IP黑名单']: 'নতুন IP ব্ল্যাকলিস্ট',
	['加入黑名单后，该IP将无法进入客服前台。']: 'আইপি ব্ল্যাকলিস্টে যুক্ত হলে, এটি গ্রাহক সেবার সামনের পাতে প্রবেশ করতে পারবে না।',
	['请完成安全验证']: 'সিকিউরিটি ভেরিফিকেশন সম্পন্ন করুন',
	['向右滑动填充拼图']: 'পাজল মেলাতে ডানদিকে স্লাইড করুন',
	['启用功能']: 'ফিচার সক্রিয় করা',
	['若IP于「限制时间」内登入超过设定的「登入次数」系统即自动加入黑名单。']: 'যদি আইপি "সীমিত সময়" এর মধ্যে নির্ধারিত "লগইন次数" এর বেশি লগইন করে, তাহলে সিস্টেম স্বয়ংক্রিয়ভাবে ব্ল্যাকলিস্টে যুক্ত হবে।',
	['限制时间']: 'সীমিত সময়',
	['时间单位不可为空']: 'সময় একক খালি হতে পারে না',
	['时间单位']: 'সময় ইউনিট',
	['登入次数']: 'প্রবেশের সংখ্যা',
	['封锁时间']: 'ব্লক সময়',
	['锁的持续时间，时间到了会自动解除']: 'লকটির স্থায়িত্ব, সময় শেষ হলে এটি স্বয়ংক্রিয়ভাবে মুক্ত হবে',
	['查询IP白名单']: 'আইপি সাদা তালিকা অনুসন্ধান',
	['删除失败']: 'মুছে ফেলার ব্যর্থতা',
	['修改失败']: 'মোডিফিকেশন ব্যর্থ',
	['拼图验证失败次数过多']: 'পাজল ভেরিফিকেশন বহুবার ব্যর্থ হয়েছে',
	['{{name}} 已于 {{time}} 拒絕加入协作']: '{{name}} {{time}} এ সহযোগিতায় যোগদানে অস্বীকার করেছে',
	['储存过滤模組成功']: 'সংগ্রহ ফিল্টার মডিউল সফল',
	['删除过滤模組成功']: 'ফিল্টার মডিউল সফলভাবে মুছে ফেলা হয়েছে',
	['解除谷歌验证成功']: 'গুগল যাচাইকরণ মাফ করা সফলভাবে',
	['确定禁用平台?']: 'প্ল্যাটফর্ম নিষ্ক্রিয় করতে নিশ্চিত?',
	['确定启用平台?']: 'প্ল্যাটফর্ম সক্রিয় করার জন্য নিশ্চিত?',
	['IP管理(客户端)']: 'IP পরিচালনা (ক্লায়েন্ট)',
	['上传']: 'আপলোড',
	['此栏位的时间会使用于报表的团队筛选']: 'এই কলামের সময় রিপোর্টের দলের ফিল্টার করতে ব্যবহার করা হবে',
	['选择团队：筛选出该团队所有客服人员在团队统计时间中的数据']: 'দল নির্বাচন করুন: দলের পরিসংখ্যানগত সময়কালে দলের সমস্ত গ্রাহক পরিষেবা কর্মীদের ডেটা ফিল্টার করুন।',
	['备注最多{{inputLimit}}个字']: 'মন্তব্য সর্বাধিক {{inputLimit}}টি অক্ষর।',
	['{{inviter}} 已于 {{time}} 将对话从 {{from}} 转接给 {{invitee}}']: '{{inviter}} {{time}} তে {{from}} আপনার কথোপকথন {{invitee}} এর কাছে হস্তান্তর করেছে',
	['小时']: 'ঘণ্টা',
	['日']: 'দিন',
	['会员IP：{{ip}} 已加入前台黑名单']: 'সদস্য আইপি：{{ip}} সামনের কালো তালিকায় যুক্ত হয়েছে',
	['新增失败']: 'নতুন সংযোজন ব্যর্থ হয়েছে',
	['会员IP被加入黑名单']: 'সদস্যের আইপি ব্ল্যাকলিস্টে অন্তর্ভুক্ত হয়েছে',
	['登入/接待时间']: 'প্রবেশ / গ্রহণের সময়',
	['timePeriodTooltipMessage']: 'সময়কাল টুলটিপ বার্তা',
	['平均接待时间']: 'গড় সেবা সময়',
	['平均登入时间']: 'গড় লগইন সময়',
	['接待时间报表']: 'অভ্যর্থনা সময়ের রিপোর্ট',
	['登入时间报表']: 'লগইন সময় প্রতিবেদন',
	['未登入']: 'লগ ইন করা হয়নি',
	['设定报表']: 'রিপোর্ট সেটআপ',
	['设定对话是否记入报表中']: 'সাক্ষাৎকারটি প্রতিবেদন অনুযায়ী রেকর্ড করতে সেট করুন',
	['平均通话时长报表']: 'গড় ফোন কল সময় রিপোর্ট',
	['平均通话数报表']: 'গড় কল সংখ্যা রিপোর্ট',
	['平均等待时间报表']: 'গড় অপেক্ষার সময়ের প্রতিবেদন',
	['客户满意度报表']: 'গ্রাহক সন্তোষ জনক রিপোর্ট',
	['平均回覆时间报表']: 'গড় প্রতিউত্তর সময় প্রতিবেদন',
	['调整原因']: 'সামঞ্জস্যের কারণ',
	['请输入调整原因']: 'আপনার সমন্বয় কারণ লিখুন',
	['调整原因不可为空']: 'সমন্বয়ের কারণ শূন্য হতে পারে না',
	['日期时间']: 'তারিখ ও সময়',
	['操作人']: 'অপারেটর',
	['原因']: 'কারণ',
	['更多']: 'বিস্তৃত',
	['收回']: 'পিছিয়ে নেওয়া',
	['设定报表成功']: 'প্রতিবেদন সেট আপ সফল',
	['平均回覆时间']: 'গড় প্রতিক্রিয়া সময়',
	['客服平均回覆时间']: 'গ্রাহক সেবার গড় প্রতিক্রিয়া সময়',
	['客户回头率']: 'গ্রাহক ফিরে আসার হার',
	['客户ID']: 'ক্লায়েন্ট আইডি',
	['客服帐号']: 'কাস্টমার সাপোর্ট অ্যাকাউন্ট',
	['小时回头率']: 'ঘণ্টা ফিরে আসার হার',
	['日回头率']: 'দিনের ফিরে আসার হার',
	['遗漏时间']: 'অবহেলিত সময়',
	['请选择遗漏时间']: 'অনুগ্রহ করে বাদ দেওয়া সময়টি নির্বাচন করুন',
	['平均遗漏时间']: 'গড় অনুপস্থিতির সময়',
	['1分钟']: '১ মিনিট',
	['2分钟']: '২ মিনিট',
	['3分钟']: '৩ মিনিট',
	['4分钟']: '৪ মিনিট',
	['5分钟']: '৫ মিনিট',
	['离开时间']: 'ছাড়ার সময়',
	['客户回头率报表']: 'কাস্টমার রিটার্ন রেট প্রতিবেদন',
	['平台报表']: 'প্ল্যাটফর্ম প্রতিবেদন',
	['对话总量']: 'ডায়ালগের মোট সংখ্যা',
	['接待总量']: 'মোট আগমন',
	['遗漏总量']: 'মোট অমিল',
	['智能客服总量']: 'বুদ্ধিমান গ্রাহক সেবা মোট量',
	['智能转客服总量']: 'স্মার্ট ট্রান্সফার কাস্টমার সার্ভিসের মোট পরিমাণ',
	['最后更新时间']: 'শেষ আপডেট সময়',
	['客服人数']: 'গ্রাহক সেবা কর্মী সংখ্যা',
	['在线客服总数']: 'অনলাইনে কাস্টমার সার্ভিসের মোট সংখ্যা',
	['等待服务']: 'সেবা অপেক্ষা',
	['正在服务']: 'সেবা দেওয়া হচ্ছে',
	['智能未转客服总量']: 'স্মার্ট আনসার্ট সেবা মোট',
	['使用平台']: 'ব্যবহারকারী প্ল্যাটফর্ম',
	['泰文名称']: 'থাইল্যান্ডের নাম',
	['请输入泰文名称']: 'অনুগ্রহ করে থাই নাম লিখুন',
	['英文名称']: 'ইংরেজি নাম',
	['请输入英文名称']: 'ইংরেজি নাম লিখুন',
	['中文名称']: '中文 নাম',
	['请输入中文名称']: 'চীনা নাম লিখুন',
	['若无需翻译请填写中文']: '如果不需要翻译，请填写中文。',
	['帐号所有报表数据将连同帐号一同删除，请问确认要删除吗？']: 'একাউন্টের সমস্ত রিপোর্টের ডেটা একাউন্টের সাথে মুছে ফেলা হবে, আপনি কি মুছে ফেলার জন্য নিশ্চিত?',
	['停用']: 'স্থগিত',
	['停用帐号']: 'অ্যাকাউন্ট স্থগিত',
	['通话总数']: 'কল যোগাযোগ',
	['等待中人数：{{pendingConversationCount}} 人']: 'অপেক্ষারত লোকের সংখ্যা: {{pendingConversationCount}} জন',
	['报表正在汇出中，请前往页面「报表下载」查看进度并进行下载。']: 'রিপোর্ট রপ্তানি করা হচ্ছে, দয়া করে "রিপোর্ট ডাউনলোড" পৃষ্ঠায় গিয়ে অগ্রগতি দেখুন এবং ডাউনলোড করুন।',
	['汇出Load Data']: 'এক্সপোর্ট লোড ডেটা',
	['报表下载']: 'রিপোর্ট ডাউনলোড',
	['全平台']: 'সম্পূর্ণ প্ল্যাটফর্ম',
	['报表类型']: 'রিপোর্টের প্রকার',
	['数据范围']: 'তথ্য পরিসর',
	['汇出时间']: 'প্রেরণের সময়',
	['完成时间']: 'সম্পন্নের সময়',
	['申请者']: 'আবেদনকারী',
	['下载']: 'ডাউনলোড',
	['重新汇出']: 'পুনঃ রফতানি',
	['处理中']: 'প্রক্রিয়াধীন',
	['已完成']: 'সম্পন্ন',
	['失败']: 'ব্যর্থতা',
	['下载成功']: 'ডাউনলোড সফল',
	['历史对话纪录']: 'ঐতিহাসিক সংলাপের রেকর্ড',
	['连线中断，请点击确定尝试恢复连线，若无法恢复将结束对话。']: 'সংযোগ বিচ্ছিন্ন হয়েছে, অনুগ্রহ করে নিশ্চিত করুন বাটনে ক্লিক করে সংযোগ পুনরুদ্ধারের চেষ্টা করুন, যদি পুনরুদ্ধার করা না যায় তবে আলাপ শেষে হবে।',
	['引用功能管理']: 'উদ্ধৃতি ফিচার পরিচালনা',
	['引用对话']: 'উদ্ধৃতি আলোচনা',
	['设定引用对话成功']: 'উদ্ধৃতি আলাপ সফলভাবে সেট করা হয়েছে',
	['客户管理']: 'গ্রাহক ব্যবস্থাপনা',
	['重要客户帐号']: 'গুরুতর ক্লায়েন্ট অ্যাকাউন্ট',
	['请输入重要客户帐号、备注等关键字']: 'দয়া করে গুরুত্বপূর্ণ ক্লায়েন্টের অ্যাকাউন্ট, মন্তব্য ইত্যাদির জন্য কিওয়ার্ডগুলি প্রবেশ করুন',
	['新增重要客户']: 'নতুন গুরুত্বপূর্ণ গ্রাহক',
	['重要客户帐号不能为空']: 'গুরুতর গ্রাহক অ্যাকাউন্ট শূন্য হতে পারে না',
	['输入多个帐号请用, 区隔']: 'একাধিক অ্যাকাউন্ট প্রবেশ করার জন্য , দিয়ে আলাদা করুন',
	['修改重要客户']: 'গুরুতর ক্লায়েন্ট সংশোধন',
	['重要帐号']: 'গুরুত রাখা অ্যাকাউন্ট',
	['会员类型']: 'সদস্যের প্রকার',
	['引用']: 'উদ্ধৃতি',
	['收回(訊息)']: 'পুনরুদ্ধার',
	['收回功能管理']: 'ফাংশন ব্যবস্থাপনা প্রত্যাহার',
	['收回提示文字不能为空']: 'পরামর্শ শব্দ খালি হতে পারে না',
	['收回对话']: 'সংলাপ ফিরিয়ে নেওয়া',
	['收回提示文字（中文）']: 'রেকর্ড বার্তা ফিরে নেওয়া',
	['收回提示文字（英文）']: 'সংকেত সঙ্কেত আপস (ইংরেজী)',
	['收回提示文字（泰文）']: 'পুনরুদ্ধার প্রম্পট টেক্সট (থাই)',
	['视频']: 'ভিডিও',
	['确定要收回讯息吗？']: 'আপনি কি সত্যিই বার্তাটি প্রত্যাহার করতে চান?',
	['设定收回功能成功']: 'সফলভাবে প্রত্যাহারের ফাংশন সেট করা হয়েছে',
	['遗漏数据']: 'মিস করা ডেটা',
	['全选']: 'সব নির্বাচন',
	['请选择使用平台']: 'দয়া করে প্ল্যাটফর্ম নির্বাচন করুন',
	['日期计算方式']: 'তারিখ গণনা পদ্ধতি',
	['以会员进入正在服务区的时间计算']: 'সদস্যের পরিষেবা অঞ্চলে প্রবেশের সময় গণনা করা হচ্ছে',
	['以会员进入等待服务区的时间计算，若是点击智能客服未进入等待服务区则以点入智能客服的时间计算']: 'সদস্য হিসাবে অপেক্ষার সেবার এলাকায় প্রবেশ করার সময় ভুলে গেলে, যদি স্মার্ট客服 ক্লিক করলে অপেক্ষার সেবার এলাকায় প্রবেশ না করে তবে স্মার্ট客服 প্রবেশের সময় গণনা করা হবে।',
	['以会员进入等待服务区的时间计算']: 'সদস্যদের সেবা দেওয়ার জন্য অপেক্ষার সময় গণনা করা',
	['以客服接通对话的时间进行计算']: 'সার্ভিসের সাথে কথোপকথনের সময় গণনা করা',
	['以会员进入等待服务区的时间进行计算']: 'সদস্যদের সেবার অপেক্ষার সময়ের ভিত্তিতে গণনা করুন',
	['以会员点击智能客服的时间计算']: 'সদস্যের ক্লিক করা স্মার্ট সার্ভিসের সময় হিসাব করা',
	['相同类型才会计算回头']: 'একই ধরনের হলে পুনরায় গণনা হবে',
	['登入联系离开后再次登入联系']: 'লগইন যোগাযোগ ছাড়ার পর আবার লগইন যোগাযোগ',
	['一通对话只会触发一次回头次数']: 'একটি কথোপকথন শুধু একবার পেছনে ফিরে যাওয়ার সংখ্যা সফল করবে।',
	['同一会员时间内连续联系3次，计算前两通对话的客服各1次回头']: 'একই সদস্য সময়ের মধ্যে পরপর ৩ বার যোগাযোগ করা হলে, প্রথম দুইটি আলাপচারিতার গ্রাহকসেবা প্রতি ১ বার ফেরত হিসাব করা হবে।',
	['每日同一会员于对话结束后{{hour}}小时内又重复联系的有效对话比例']: 'প্রতিদিন একই সদস্য তাদের কথোপকথনের শেষে {{hour}} ঘন্টার মধ্যে পুনরায় যোগাযোগ করার কার্যকর কথোপকথনের অনুপাত',
	['未登入联系离开后再次未登入联系']: 'এখন লগ ইন না হলে যোগাযোগ ছাড়ার পর আবার লগ ইন না হলে যোগাযোগ',
	['请输入重要客户帐号']: 'দয়া করে জরুরী ক্রেতার অ্যাকাউন্ট প্রবেশ করুন',
	['开始日期']: 'শুরুর তারিখ',
	['结束日期']: 'শেষ তারিখ',
	['标签名称/数量']: 'লেবেল নাম/পরিমাণ',
	['暂无数据']: 'ডেটা নেই',
	['AI客服设定']: 'এআই গ্রাহকসেবা সেটিং',
	['AI共同设定']: 'AI সম্মিলিত নির্ধারণ',
	['平台AI设定']: 'প্ল্যাটফর্ম AI সেটিং',
	['平台 AI SKILL 设定']: 'প্ল্যাটফর্ম AI SKILL সেটিং',
	['指令输入说明']: 'নির্দেশনা ইনপুট বর্ণনা',
	['输入文字档']: 'ইনপুট টেক্সট ফাইল',
	['不需要区分功能']: 'কার্যকারিতা আলাদা করার প্রয়োজন নেই',
	['套用平台']: 'প্ল্যাটফর্ম প্রয়োগ',
	['请输入指令']: 'দয়া করে নির্দেশনা প্রবেশ করান',
	['AI与会员对话超过 <<inputNumber>> 轮后需要通知客服人员']: 'AI সদস্যের সাথে <<inputNumber> রাউন্ডের বেশি সময় ধরে কথা বলার পরে, গ্রাহক পরিষেবাকে অবহিত করা হবে।',
	['指令']: 'নির্দেশ',
	['AI开关']: 'এআই সুইচ',
	['AI客服名称']: 'এআই客服名称',
	['AI客服名称不能为空']: 'AI সেবা গ্রাহক নাম শূন্য হতে পারে না',
	['请输入AI客服名称']: 'এআই গ্রাহক সেবার নাম লিখুন',
	['是否要关闭AI客服？关闭后将无法再度开启AI客服']: 'আপনি কি AI গ্রাহক পরিষেবা বন্ধ করতে চান? এটি বন্ধ করার পরে আপনি আর AI গ্রাহক পরিষেবা চালু করতে পারবেন না।',
	['侦测到对话有异常状态，请尽快处理']: 'সংলাপে অস্বাভাবিক অবস্থা শনাক্ত করা হয়েছে, অনুগ্রহ করে দ্রুত ব্যবস্থা নিন।',
	['需要转接人工客服，请尽快处理']: 'প্রয়োজনীয় জনশক্তি সেবায় সংযোগ করতে, দয়া করে যত তাড়াতাড়ি সম্ভব ব্যবস্থা নিন।',
	['总平均通话时长']: 'মোট গড় ফোন কলের সময়',
	['AI平均通话时长']: 'AI গড় কলের দৈর্ঘ্য',
	['人工平均通话时长']: 'কৃত্রিম গড় কলের সময়',
	['每日总平均']: 'প্রতিদিনের মোট গড়',
	['AI日平均']: 'এআই দৈনিক গড়',
	['人工日平均']: 'কৃত্রিম দৈনিক গড়',
	['通话总量']: 'কলকারী মোট',
	['AI通话总量']: 'এআই কলের মোট সংখ্যা',
	['共同']: 'সাধারণ',
	['总计']: 'মোট',
	['总计请勿超过{{limit}}字']: 'মোটে {{limit}} শব্দ অতিক্রম করবেন না',
	['总平均回覆时间']: 'মোট গড় উত্তর দেওয়ার সময়',
	['AI平均回覆时间']: 'এআই গড় প্রতিক্রিয়া সময়',
	['人工平均回覆时间']: 'কৃত্রিম গড় প্রতিক্রিয়া সময়',
	['AI日总量']: 'এআই দৈনিক মোট',
	['人工日总量']: 'কৃত্রিম দিনের মোট পরিমাণ',
	['指令不能为空']: 'নির্দেশ শূন্য হতে পারে না',
	['{{name}} 已于 {{time}} 开启AI']: '{{name}} {{time}} এ AI চালু করেছে',
	['{{name}} 已于 {{time}} 关闭AI']: '{{name}} AI {{time}} বন্ধ করেছে',
	['人机合作日总量']: 'মানব-মেশিন সহযোগিতার দৈনিক মোট সংখ্যা',
	['人工通话总量']: 'মানবিক কথা বলার মোট সংখ্যা',
	['人机合作通话总量']: 'মান-যন্ত্র সহযোগিতা কথোপকথনের মোট সংখ্যা',
	['以对话建立时间计算']: 'আলোচনার ভিত্তিতে সময় গণনা করা',
	['侦测到对话有异常状态 - 对话次数超过限制']: 'কথোপকথনে অস্বাভাবিক অবস্থা শনাক্ত করা হয়েছে - কথোপকথনের সংখ্যা সীমা অতিক্রম করেছে।',
	['侦测到对话有异常状态 - 系统发生错误']: 'সংলাপে অস্বাভাবিক অবস্থা শনাক্ত করা হয়েছে — সিস্টেমে একটি ত্রুটি ঘটেছে।',
	['人机合作-人工日平均']: 'মানব-যন্ত্র সহযোগিতা - কৃত্রিম অভ্যস্ত গড়',
	['人机合作-AI日平均']: 'মানব-যন্ত্র সহযোগিতা - AI দৈনিক গড়',
	['人机合作-人工平均通话时长']: 'মানব-মেশিন সহযোগিতা -人工平均通话时长',
	['人机合作-AI平均通话时长']: 'মানব-যন্ত্র সহযোগিতা-AI গড় কল সময়',
	['侦测到对话有异常状态 - 等待AI API超过两分钟']: 'কথোপকথনে অস্বাভাবিক অবস্থা সনাক্ত করা হয়েছে - AI API-এর জন্য দুই মিনিটের বেশি সময় ধরে অপেক্ষা করা হচ্ছে।',
	['侦测到对话有异常状态 - AI 发生错误']: 'আলাপের মধ্যে অস্বাভাবিক অবস্থা শনাক্ত হয়েছে - AI ত্রুটি ঘটেছে',
	['侦测到对话有异常状态 - AI 没有回复']: 'কথোপকথনে অস্বাভাবিক অবস্থা শনাক্ত করা হয়েছে - AI কোনো উত্তর দেয়নি।',
	['数据']: 'ডেটা',
	['指令不能超过{{limit}}字']: 'নির্দেশনা {{limit}} শব্দের বেশি হতে পারেনা',
	['数据不能为空']: 'ডেটা খালি হতে পারে না',
	['数据不能超过100万字']: 'ডেটা ১০০০০০০ শব্দ অতিক্রম করতে পারে না',
	['需{{limit}}字以内']: 'আপনি {{limit}} অক্ষরের মধ্যে প্রয়োজন',
	['数据输入说明']: 'ডেটা প্রবেশ নির্দেশিকা',
	['需100万字以内']: 'মোট ১০০,০০০ শব্দের মধ্যে হতে হবে',
	['至少要有一组 ~~~~~ 与 =====']: 'অন্তত একটি ~~~~~ এবং ===== জোড়া থাকতে হবে',
	['分隔符号 ~~~~~ 与 ===== 需成对出现']: 'বিভাজক ~~~~~ এবং ===== অবশ্যই জোড়ায় থাকতে হবে',
	['需以 ===== 结尾']: 'অবশ্যই ===== দিয়ে শেষ হতে হবে',
	['标题底下使用5个波浪号并换行，波浪号的开头与结尾不能有其他文字或空格']: 'শিরোনামের নিচের লাইনে ৫টি টিল্ড ব্যবহার করুন, তার আগে বা পরে অন্য কোনো লেখা বা স্পেস থাকতে পারবে না',
	['内容底下使用5个等号并换行，等号的开头与结尾不能有其他文字或空格']: 'বিষয়বস্তুর নিচের লাইনে ৫টি সমান চিহ্ন ব্যবহার করুন, তার আগে বা পরে অন্য কোনো লেখা বা স্পেস থাকতে পারবে না',
	['范例']: 'উদাহরণ',
	['标题A（可多行）']: 'শিরোনাম A (একাধিক লাইন সম্ভব)',
	['内容A（可多行，可含任何文字）']: 'বিষয়বস্তু A (একাধিক লাইন, যেকোনো লেখা থাকতে পারে)',
	['标题B（可多行）']: 'শিরোনাম B (একাধিক লাইন সম্ভব)',
	['内容B（可多行，可含任何文字）']: 'বিষয়বস্তু B (একাধিক লাইন, যেকোনো লেখা থাকতে পারে)',
	['模型顺序（上方模型优先使用，失效时自动往下切换）']: 'মডেলের ক্রম (উপরের মডেলটি আগে ব্যবহৃত হয়, ব্যর্থ হলে স্বয়ংক্রিয়ভাবে পরেরটিতে চলে যায়)',
	['主要']: 'প্রধান',
	['备援{{index}}']: 'ব্যাকআপ {{index}}',
	['新增备援模型']: 'ব্যাকআপ মডেল যোগ করুন',
	['请输入数据']: 'ডেটা প্রবেশ করুন',
	['正在转接中...']: 'সচল হচ্ছে...',
	['（中文）']: '(中文) ',
	['（英文）']: '(ইংরেজি)',
	['（泰文）']: '(ไทย)',
	['（越南文）']: '(ভিয়েতনামিজ)',
	['越南文名称']: 'ভিয়েতনামী নাম',
	['请输入越南文名称']: 'ভিয়েতনামী নাম লিখুন',
	['模式']: 'মডেল',
	['越南语']: 'ভিয়েতনামেস্ত',
	['IP白名单设定']: 'আইপি সাদা তালিকা সেটিং',
	['建立时间']: 'সৃষ্টির সময়',
	['批次删除']: 'ব্যাচ মুছে ফেলুন',
	['请确认是否删除 IP 白名单？']: 'দয়া করে নিশ্চিত করুন যে আপনি আইপি সাদা তালিকা মুছে ফেলতে চান?',
	['开启快捷选单']: 'শর্টকাট মেনু খুলুন',
	['收合快捷选单']: 'শর্টকাট মেনু বন্ধ করুন',
	['是否有收回人员讯息']: 'কোনও প্রত্যাহারকৃত কর্মী তথ্য আছে কি?',
	['是否有收回AI讯息']: 'এআই বার্তা প্রত্যাহার করা হয়েছে কি?',
	['消息已被客服撤回']: 'সংবাদটি গ্রাহক সেবা কর্তৃক প্রত্যাহার করা হয়েছে',
	['用户快捷选单管理']: 'ব্যবহারকারী দ্রুত মেনু ব্যবস্থাপনা',
	['电脑预览']: 'কম্পিউটার প্রিভিউ',
	['手机预览']: 'মোবাইল পরিদর্শন',
	['档案格式：PNG、JPG、JPEG']: 'ফাইল ফরম্যাট: PNG, JPG, JPEG',
	['请选择上传档案']: 'ফাইল আপলোড করতে নির্বাচন করুন',
	['新增快捷成功']: 'নতুন শর্টকাট সফলভাবে যুক্ত হয়েছে',
	['修改快捷成功']: 'সম্পাদনা সফল হয়েছে',
	['设定快捷选单成功']: 'শর্টকাট মেনু সফলভাবে সেট করা হয়েছে',
	['删除快捷成功']: 'ডিলিট শর্টকাট সফল',
	['确定删除此快捷？']: 'এই শর্টকাট মুছে ফেলতে নিশ্চিত?',
	['新增内容']: 'নতুন সামগ্রী',
	['选项內容']: 'বিকল্প বিষয়বস্তু',
	['{{itemLabel}}內容不能为空']: '{{itemLabel}} বিষয় খালি হতে পারে না',
	['请输入{{itemLabel}}标题']: 'দয়া করে {{itemLabel}} শিরোনাম প্রবেশ করুন',
	['请输入{{itemLabel}}选项']: 'অনুগ্রহ করে {{itemLabel}} বিকল্পটি প্রবেশ করুন',
	['{{text}}不可为空']: '{{text}} খালি হতে পারে না',
	['显示更多']: 'আরো দেখান',
	['公告标签']: 'বিজ্ঞপ্তি লেবেল',
	['请选择公告标签']: 'দয়া করে ঘোষণার ট্যাগ নির্বাচন করুন',
	['{{text}}标题']: '{{text}} শিরোনাম',
	['{{text}}內文']: '{{text}}এর বিষয়',
	['{{text}}最多{{inputLimit}}个字']: '{{text}} সর্বাধিক {{inputLimit}} টি শব্দ',
	['公告内文档案大小总计不得大于10MB']: 'ঘোষণা নথির আকার সর্বমোট 10MB-এর বেশি হতে পারবে না।',
	['用户尚未离开，确认要完成对话？']: 'ব্যবহারকারী এখনও বের হয়ে যাননি, আপনি কি নিশ্চিত যে কথোপকথন সম্পন্ন করতে চান?',
	['{{name}} 已于 {{time}} 离开对话']: '{{name}} {{time}} এ আলাপ ছেড়ে গেছে',
	['客服人员']: 'গ্রাহক পরিষেবা কর্মী',
	['*新增多个IP请使用逗号「 , 」隔开']: 'নতুন একাধিক IP যোগ করতে কমা「 , 」ব্যবহার করুন',
	['是否新增IP白名单？']: 'আইপি সাদা তালিকা যোগ করা হবে কি?',
	['IP已存在']: 'আইপি ইতিমধ্যে উপস্থিত',
	['监控区管理']: 'পর্যবেক্ষণ এলাকা পরিচালনা',
	['监控区开关']: 'পর্যবেক্ষণ এলাকা সুইচ',
	['设定监控区开关成功']: 'পর্যবেক্ষণ এলাকা সুইচ সেট করা সফল হয়েছে',
	['启用功能后，等待服务区会增加一个[监控区]页签，显示全平台被AI拦截的对话与未读时间最长的5通对话，点击可快速跳转至相应对话。']: 'ফাংশন সক্রিয় করার পর, অপেক্ষমাণ সেবা অঞ্চলে একটি [পর্যবেক্ষণ এলাকা] ট্যাব যুক্ত হবে, যা পুরো প্ল্যাটফর্মে AI দ্বারা আটকানো কথোপকথন এবং সবচেয়ে দীর্ঘ সময় ধরে অপঠিত ৫টি কথোপকথন প্রদর্শন করবে, ক্লিক করলে দ্রুত সংশ্লিষ্ট কথোপকথনে চলে যেতে পারবেন।',
	['{{name}} 新增了标签 {{tag}}']: '{{name}} নতুন ট্যাগ {{tag}} যোগ করেছে',
	['{{name}} 移除了标签 {{tag}}']: '{{name}} ট্যাগ {{tag}} সরিয়ে নিয়েছে',
	['状态切换为暂离']: 'অবস্থা অস্থায়ীভাবে পরিবর্তিত হচ্ছে',
	['状态切换为工作中']: 'কর্মরত হিসাবে অবস্থা পরিবর্তন করা',
	['监控区']: 'পর্যবেক্ষণ এলাকা',
	['自动接线管理']: 'স্বয়ংক্রিয় তার্কনিক পরিচালনা',
	['客服全平台接待数量达到上限后，系统不会自动接入等待服务区的对话，客服人员手动接入数量不限制。']: 'কাস্টমার সাপোর্ট সমস্ত প্ল্যাটফর্মে গ্রহণের সংখ্যা সীমা পৌঁছানোর পরে, সিস্টেম স্বয়ংক্রিয়ভাবে সার্ভিস ওয়েইটিং এরিয়ার কথোপকথনে যুক্ত হবে না, কাস্টমার সার্ভিস কর্মীদের জন্য ম্যানুয়ালি যুক্ত হওয়ার সংখ্যা সীমাবদ্ধ নয়।',
	['自动接线数量上限']: 'স্বয়ংক্রিয় সংযোগের সংখ্যা সীমা',
	['设定自动接线成功']: 'স্বয়ংক্রিয় সংযোগ সফলভাবে সেট করা হয়েছে',
	['{{name}} 进线']: '{{name}} ফোন করছে',
	['工作/暂离时间']: 'কাজ/ছুটি সময়',
	['工作时长报表']: 'কর্মজীবনের সময়কাল প্রতিবেদন',
	['暂离时长报表']: 'অস্থায়ী অবসর সময় রিপোর্ট',
	['平均工作时长']: 'গড় কাজের সময়',
	['平均暂离时长']: 'গড় অপ্রচলিত সময়',
	['关键字提醒']: 'কীওয়ার্ড বিজ্ঞপ্তি',
	['客户发话']: 'গ্রাহক কথা বলছে',
	['AI发话']: 'AI বলছে',
	['发话来源']: 'বক্তব্য উৎস',
	['请输入发话来源、关键字']: 'অনুগ্রহ করে কথা বলার উত্স, কীওয়ার্ড লিখুন',
	['新增关键字']: 'নতুন কীওয়ার্ড যোগ করুন',
	['修改关键字']: 'সংশোধন কীওয়ার্ড',
	['新增关键字成功']: 'নতুন কীওয়ার্ড সফলভাবে যুক্ত হয়েছে',
	['修改关键字成功']: 'কীওয়ার্ড সফলভাবে পরিবর্তন করা হয়েছে',
	['删除关键字成功']: 'কীওর্ড মুছে ফেলা সফল হয়েছে',
	['是否删除此关键字？']: 'এই কীওয়ার্ডটি মুছে ফেলার কি?',
	['请用「；」来分隔不同关键字，关键字不得超过100个字']: 'অনুগ্রহ করে পৃথক কীওয়ার্ডগুলিকে "；" দ্বারা ভাগ করুন，কীওয়ার্ডগুলি ১০০টির বেশি অক্ষর হতে পারবে না。',
	['客户触发关键字 [{{word}}] 请客服人员注意']: 'গ্রাহক কিওয়ার্ড [{{word}}] ট্রিগার করেছে দয়া করে গ্রাহক সেবা কর্মীদের নজর দিন',
	['AI触发关键字 [{{word}}] 请客服人员注意']: 'AI ট্রিগার কীওয়ার্ড [{{word}}] দয়া করে গ্রাহক সেবা কর্মীদের নজরে রাখুন',
	['请输入通知时间']: 'দয়া করে বিজ্ঞপ্তির সময় প্রবেশ করান',
	['自动接线开关']: 'অটোমেটিক সুইচ',
	['自动接线数量上限不可为空']: 'স্বয়ংক্রিয় সংযোগের সংখ্যার সর্বাধিক সীমা খালি থাকতে পারে না',
	['请输入数量上限']: 'অনুগ্রহ করে সীমা সংখ্যা লিখুন',
	['离开状态侦测开关']: 'ছাড়া অবস্থা শনাক্তকরণ সুইচ',
	['开启后当客服人员为平台最后一个工作状态或仍有接待中且无协作给他人对话时，无法切换为离开状态。']: 'প্রবেশ করলে যখন সেবা কর্মী প্ল্যাটফর্মের শেষ কাজের অবস্থান বা এখনও উপস্থিত রয়েছে এবং অন্যদের সংলাপের জন্য সহযোগিতা নেই, তখন তারা ছেড়ে যাওয়ার অবস্থায় স্যুইচ করতে অক্ষম।',
	['离开时间通知开关']: 'প্রস্থান সময় বিজ্ঞপ্তি সুইচ',
	['通知时间不可重复']: 'নোটিশের সময় পুনরাবৃত্তি করা যাবে না',
	['侦测权限CS帐号离开时间，离开时间达设定时间时通知权限manager以上的帐号，以及触发离开时间的CS帐号本人。']: 'সনাক্তকরণ অধিকার CS অ্যাকাউন্টের ছাড়ার সময়, ছাড়ার সময় নির্ধারিত সময় পৌঁছালে অধিকার ব্যবস্থাপকের উপরে থাকা অ্যাকাউন্ট এবং ছাড়ার সময়ের CS অ্যাকাউন্টের মালিককে জানানো হবে।',
	['最后暂离时间报表']: 'শেষ অন্তর্বর্তীকালীন সময় রিপোর্ট',
	['平均最后暂离时间']: 'গড় চূড়ান্ত অভিযোজন সময়',
	['{{name}} 离开时间已达 [{{minute}}] 分钟 !']: '{{name}} ছাড়ার সময় [{{minute}}] মিনিট পেরিয়ে গেছে!',
	['历史对话记录下载']: 'ইতিহাসের সংলাপের রেকর্ড ডাউনলোড করুন',
	['使用模式']: 'ব্যবহারের প্যাটার্ন',
	['标准模式']: 'মানক মোড',
	['ID模式']: 'ID প্যাটার্ন',
	['即进模式']: 'অতিঘোষণা মোড',
	['复制即进网址']: 'কপির সাথে সাইটে প্রবেশ করুন',
	['生成新网址']: 'নতুন ওয়েবসাইট তৈরি করা',
	['需提供客户Profile资料的标准模式，此模式为系统预设模式。']: 'গ্রাহকের প্রোফাইল তথ্যের স্ট্যান্ডার্ড মোড প্রদান করতে হবে, এই মোডটি সিস্টেম দ্বারা পূর্বনির্ধারিত মোড।',
	['输入ID 进入客服，可不提供客戶Profile资料。']: 'আইডি প্রবেশ করান, গ্রাহক প্রোফাইল তথ্য প্রদান করা আবশ্যক নয়।',
	['透过即进网址可直接进入客服系统，无需提供资料，系统自动给予随机访客名称。']: 'আপনার সঙ্গে যোগাযোগ করার জন্য, আপনি সরাসরি ওয়েবসাইটে প্রবেশ করতে পারেন, কোন তথ্য প্রদান করার প্রয়োজন নেই, সিস্টেম স্বয়ংক্রিয়ভাবে এলোমেলো দর্শক নাম দেয়।',
	['请再次确认是否從 [<<prevTypeText>>] 切至 [<<nextTypeText>>]']: 'দয়া করে আবার নিশ্চিত করুন যে [<<prevTypeText>>] থেকে [<<nextTypeText>>] এ পরিবর্তন হচ্ছে।',
	['以下是即进网址']: 'নিচে অবস্থিত ওয়েবসাইট',
	['复制网址']: 'কপি লিঙ্ক',
	['使用模式切换成功']: 'মোড পরিবর্তন সফল',
	['请再次确认是否更换网址 ，一经更换<<redText>>']: 'দয়া করে আবার নিশ্চিত করুন যে ওয়েবসাইটটি পরিবর্তন হয়েছে, একবার পরিবর্তিত হলে <<redText>>',
	['当前即进网址']: 'বর্তমান উল্লেখিত ওয়েবসাইট',
	['新即进网址']: 'নতুন সাইট网址',
	['复制即进网址成功']: 'কপি করা সাফল্যের সাথে ওয়েবসাইটে প্রবেশ।',
	['报表统计']: 'প্রতিবেদন পরিসংখ্যান',
	['操作時間']: 'অপারেশন সময়',
	['统计类型']: 'পরিসংখ্যান প্রকার',
	['请选择统计类型']: 'অনুগ্রহ করে পরিসংখ্যানের প্রকার নির্বাচন করুন',
	['查询参数']: 'অনুসন্ধান প্যারামিটার',
	['申请时间']: 'আবেদন সময়',
	['产出时间']: 'উৎপাদনের সময়',
	['申请帐号']: 'অ্যাকাউন্টের জন্য আবেদন',
	['详细资料']: 'বিস্তারিত তথ্য',
	['重新执行统计']: 'পুনঃসম্পাদনা পরিসংখ্যান',
	['执行统计']: 'পরিসংখ্যান পরিচালনা',
	['登入时间范围']: 'লগইন সময়ের সীমা',
	['选择团队：筛选出该团队所有客服人员']: 'দল নির্বাচন করুন: সেই দলের সকল গ্রাহক সেবা কর্মী বাছাই করুন',
	['API接收日志']: 'এপিআই গ্রহণ লগ',
	['新增来源']: 'নতুন উৎস',
	['CS']: 'সি এস',
	['包网']: 'প্যাকেজ',
	['包网API']: 'প্যাকেজ নেটওয়ার্ক API',
	['第 {{min}} - {{max}} 笔']: '第 {{min}} - {{max}} বিঁণ',
	['选择的日期区间需小于等于{{limit}}天']: 'নির্বাচিত তারিখের পরিসীমা {{limit}} দিনের কম বা সমান হতে হবে।',
	['请选择日期时间查询条件']: 'তারিখ এবং সময় অনুসন্ধানের শর্ত নির্বাচন করুন',
	['类型']: 'প্রকার',
	['公司']: 'কোম্পানি',
	['请输入公司']: 'দয়া করে কোম্পানি প্রবেশ করুন',
	['会员帐号']: 'সদস্য অ্যাকাউন্ট',
	['请输入会员帐号']: 'দয়া করে সদস্যের অ্যাকাউন্ট নম্বর লিখুন',
	['是否查看详细资料？']: 'বিস্তারিত তথ্য দেখেছেন কি?',
	['传送资料']: 'ডেটা পাঠানো',
	['CS回覆资料']: 'CS প্রতিক্রিয়া তথ্য',
	['内容']: 'বিষয়',
	['请选择进入的公司']: 'মৌলিক কোম্পানি নির্বাচন করুন',
	['指令数据更新纪录']: 'নির্দেশনার ডেটা আপডেট রেকর্ড',
	['1.排序机制：所有公司的指令将统一排序处理，确保系统高效运作。']: '১. বাছাই প্রক্রিয়া: সিস্টেমের দক্ষ পরিচালনা নিশ্চিত করার জন্য কোম্পানির সমস্ত নির্দেশাবলী সমানভাবে বাছাই এবং প্রক্রিয়াজাত করা হবে।',
	['2.数据隔离：用户仅能查看自己公司的更新记录，无法查看其他公司的记录。']: '২. ডেটা বিচ্ছিন্নতা: ব্যবহারকারী শুধুমাত্র নিজের কোম্পানির আপডেট রেকর্ড দেখতে পারবে, অন্য কোম্পানির রেকর্ড দেখতে পারবে না।',
	['微调训练']: 'মাইক্রো-টিউনিং ট্রেইনিং',
	['执行微调']: 'মাইক্রো টিউনিং',
	['操作帐号']: 'অ্যাকাউন্ট পরিচালনা',
	['是否修改AI API?']: 'এআই API কি সংশোধন করা হবে?',
	['保存设置']: 'সংরক্ষণ সেটিংস',
	['修改AI API成功']: 'এআই এপিআই সফলভাবে পরিবর্তন করা হয়েছে',
	['请输入{{text}}']: 'অনুগ্রহ করে {{text}} লিখুন',
	['{{text}}不能超过{{limit}}字元']: '{{text}} {{limit}} অক্ষরের বেশি হতে পারবে না',
	['AI API']: 'এআই এপিআই',
	['微调训练记录']: 'মাইক্রো টিউনিং প্রশিক্ষণের রেকর্ড',
	['模型名称']: 'মডেল নাম',
	['新增文本']: 'নতুন টেক্সট',
	['修改文本']: 'বাক্যসমূহ পরিবর্তন করুন',
	['请输入名称']: 'নাম লিখুন',
	['取消修改微调文本']: 'মাইক্রো-টেক্সট সংশোধন বাতিল করুন',
	['角色不可为空']: 'পাত্র শূন্য হতে পারে না',
	['请选择角色']: '角色 নির্বাচন করুন',
	['内容不可为空']: 'বিষয় খালি হতে পারবে না',
	['请输入内容']: 'দয়া করে বিষয়বস্তু লিখুন',
	['系统']: 'জ-system',
	['会员']: 'সদস্য',
	['AI']: 'এআই',
	['请确认是否取消？']: 'দয়া করে নিশ্চিত করুন যে আপনি বাতিল করতে চান?',
	['新增微调文本成功']: 'নতুন টেক্সট সামঞ্জস্য সফল হয়েছে',
	['修改微调文本成功']: 'সফলভাবে টেক্সট সংশোধন করা হয়েছে',
	['自定模型名称']: 'স্বনির্ধারিত মডেল নাম',
	['微调确认讯息']: 'মাইক্রো-অ্যাডজাস্টমেন্ট নিশ্চিতকরণ বার্তা',
	['请确认是否执行微调训练？']: 'দয়া করে নিশ্চিত করুন আপনি মাইক্রো টিউনিং ট্রেনিং চালিয়ে যেতে চান কি?',
	['删除微调文本']: 'মাইক্রোফাইন টেক্সট মুছে ফেলুন',
	['请确认是否刪除？']: 'দয়া করে নিশ্চিত করুন আপনি মোছার জন্য প্রস্তুত কিনা?',
	['刪除微调文本成功']: 'মাইক্রো টিউনিং টেক্সট সফলভাবে মুছে ফেলা হয়েছে',
	['请输入模型名称']: 'মডেলের নাম প্রবেশ করুন',
	['执行微调成功']: 'মাইক অসাধারণ সফল',
	['取消修改文本成功']: 'টেক্সট পরিবর্তন বাতিল সফল',
	['取消新增文本成功']: 'নতুন টেক্সট বাতিল করা সফল হয়েছে',
	['您已成功登出客服系统。']: 'আপনি সফলভাবে কাস্টমার সার্ভিস সিস্টেম থেকে লগ আউট করেছেন।',
	['如需重新登录，请返回包网！']: 'পুনরায় লগইন করতে, দয়া করে বাজেট ওয়েব সাইটে ফিরে যান!',
	['您已成功登出客服系统管理端。']: 'আপনি সফলভাবে গ্রাহক সেবা সিস্টেমের প্রশাসনিক প্যানেল থেকে লগ আউট করেছেন।',
	['当「平均等待时间」显示为 0 秒时，可能的原因如下：']: 'যখন "গড় অপেক্ষার সময়" 0 সেকেন্ড বলে প্রবাহিত হয়, সম্ভাব্য কারণগুলি হল:',
	['1.当日所有对话的等待时间均为 0 秒（例如因自动接线或即时应答，无需等待）。']: '১। ঐ দিন সমস্ত কথোপকথনের জন্য অপেক্ষার সময় ০ সেকেন্ড (যেমন স্বয়ংক্রিয় সংযোগ বা তাৎক্ষণিক উত্তরের কারণে, অপেক্ষা করার প্রয়োজন নেই)।',
	['2.根据公式 「每日总等待时间 ÷ 每日对话数量」，计算结果经四舍五入后为 0 秒。']: '২. সূত্র অনুযায়ী "প্রতিদিনের মোট অপেক্ষার সময় ÷ প্রতিদিনের কথোপকথনের সংখ্যা", হিসাবের ফলাফল চারটি প্রান্তে বৃত্তাকার করার পর ০ সেকেন্ড।',
	['系统显示为 「未登入」 时，表示该帐号在其设定的团队时间内未产生任何对话数据。']: 'সিস্টেম "লগ ইন হয়নি" হিসাবে দেখাল, তা বোঝায় যে ওই অ্যাকাউন্টটি তার সেট করা দলের সময়ের মধ্যে কোনো কথোপকথন তথ্য উৎপন্ন হয়নি।',
	['加入微调']: 'মাইক্রো টিউনিং',
	['启用API Key']: 'এপিআই কী সক্রিয় করুন',
	['微调汇入对话记录']: 'মাইক্রোফাইন টোনিং সংলাপ রেকর্ড',
	['对话数量']: 'সংলাপের সংখ্যা',
	['文本最后角色需为AI或客服人员']: 'টেক্সটের শেষে চরিত্রটি AI বা গ্রাহক সেবা কর্মী হতে হবে।',
	['汇入微调文本']: 'মাইক্রো টিউনিং টেক্সট যুক্ত করুন',
	['檔案格式：CSV，且档案大小不得大于']: 'ফাইল ফরম্যাট: CSV এবং ফাইলের আকার  হতে হবে না বেশি',
	['文本最后角色需为AI或客服人员，请修改后再进行汇出或执行微调']: 'পাঠ্যের শেষ চরিত্রটি AI বা গ্রাহক সেবার লোক হতে হবে, দয়া করে এটি সংশোধন করুন এবং তারপর রপ্তানি বা মাইক্রো অ্যাডজাস্ট করুন।',
	['批量加入微调']: 'ম্যাসেফাইন করুন',
	['自定加入微调的名称']: 'স্বনির্ধারিত ফাইনটিউন নাম যোগ করুন',
	['微调名称']: 'মাইক্রো টিউন নাম',
	['请输入微调的名称']: '微调ের নাম প্রবেশ করুন',
	['微调的名称']: 'মাইক্রো-টিউনিংয়ের নাম',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔']: 'অনুগ্রহ করে নিশ্চিত করুন যে আপনাকে ভরাট মুছে ফেলতে হবে (মোট {{selectedFineTuningRecordsLength}} টি',
	['已取消']: 'বাতিল করা হয়েছে',
	['取消微调']: 'মাইক্রো-টিউনিং বাতিল করুন',
	['取消微调成功']: 'মাইক্রো-টিউনিং বাতিল সফল',
	['取消此笔客服系统微调训练时，需要同时取消对应的 OpenAI 后台微调训练。只有两者均取消后，微调训练才会被完整移除。请确认是否要取消此客服系统微调训练？']: 'এই গ্রাহক সেবা সিস্টেমের সূক্ষ্ম সামঞ্জস্য প্রশিক্ষণ বাতিল করতে, আপনাকে একসাথে OpenAI ব্যাকএন্ডের সূক্ষ্ম সামঞ্জস্য প্রশিক্ষণও বাতিল করতে হবে। শুধুমাত্র যখন উভয়ই বাতিল করা হবে, তখন সূক্ষ্ম সামঞ্জস্য প্রশিক্ষণ সম্পূর্ণরূপে সরানো হবে। আপনি কি এই গ্রাহক সেবা সিস্টেমের সূক্ষ্ম সামঞ্জস্য প্রশিক্ষণ বাতিল করতে চান?',
	['复制快捷语成功']: 'কপি শর্টকাট সাফল্য',
	['复制常用图片成功']: 'নিরবচ্ছিন্নভাবে সাধারণ ছবি কপি করা হয়েছে সফলভাবে',
	['左侧']: 'বামদিক',
	['右侧']: 'ডানপাশ',
	['{{text}}正在服务{{total}}则对话']: '{{text}}{{total}}টি কথোপকথনে সেবা করছে',
	['新增跑马灯成功']: 'নতুন মারার বাতি সফলভাবে যুক্ত হয়েছে',
	['修改跑马灯成功']: 'মার্কিং সাফল্যমন্ডিত হলেও',
	['刪除跑马灯成功']: 'মার্কেটিং বার (প্যানেল) মুছে ফেলা সফল',
	['启用跑马灯成功']: 'মার্চিং টেক্সট সক্রিয় করা হয়েছে',
	['停用跑马灯成功']: 'রোলিং বার ভালভাবে বন্ধ করা হয়েছে',
	['对象栏位']: 'বস্তু কলাম',
	['显示跑马灯内容']: 'প্রদর্শন রাশি আলো বিষয়বস্তু',
	['请确认是否启用跑马灯？']: 'দয়া করে নিশ্চিত করুন যে আপনারা মেরিডিয়ান চালু করতে চান?',
	['请确认是否停用跑马灯？']: 'দয়া করে নিশ্চিত করুন যে কি আপনি রোলিং লাইট বন্ধ করবেন?',
	['请确认是否删除跑马灯？']: 'দয়া করে নিশ্চিত করুন যে আপনি মারকী মুছে ফেলতে চান?',
	['{{text}}最多{{inputLimit}}组']: '{{text}} সর্বাধিক {{inputLimit}} গ্রুপ',
	['数值范围']: 'সংখ্যাগত পরিসর',
	['数值不能为空']: 'মানের শূন্য হতে পারে না',
	['数值']: 'সংখ্যা',
	['请输入数字']: 'দয়া করে একটি সংখ্যা প্রবেশ করুন',
	['输入多组文字请用, 区隔']: 'বহু সেট লেখার জন্য দয়া করে , দিয়ে পৃথক করুন',
	['当用户符合对象设定名称及栏位规则中的内容时，才会生效跑马灯推广']: 'যখন ব্যবহারকারী প্রযোজ্য বস্তু নির্দিষ্ট নাম এবং কলাম নিয়মগুলির অধীনে বিষয়বস্তু পূরণ করে, তখনই চলছে বাতি প্রচার কার্যকর হবে।',
	['新增跑马灯']: 'নতুন দৌড়ানোর বাতি',
	['对象栏位不能为空']: 'অবজেক্ট ফিল্ড খালি হতে পারে না',
	['请输入对象栏位']: 'অবজেক্ট স্তম্ভটি প্রবেশ করুন',
	['栏位规则']: 'কলাম নীতি',
	['栏位规则不能为空']: 'সেকশন নিয়ম শূন্য হতে পারে না',
	['请选择栏位规则']: 'অনুগ্রহ করে কলাম নিয়ম নির্বাচন করুন',
	['开头图示']: 'শুরুর চিত্র',
	['开头图示不能为空']: 'শুরু চিত্র খালি থাকতে পারে না',
	['请选择开头图示']: 'প্রারম্ভিক চিত্র নির্বাচন করুন',
	['跑马灯内容']: 'দৌড়ের বাতি বিষয়বস্তু',
	['修改跑马灯']: 'মার্কেটিং বিজ্ঞাপন পরিবর্তন',
	['变更的平台设定将同步套用至下级角色，是否确认修改？']: 'প্ল্যাটফর্মের সেটিং পরিবর্তন নিম্নস্তরের চরিত্রগুলির উপর প্রযোজ্য হবে, আপনি কি পরিবর্তন নিশ্চিত করবেন?',
	['确认要删除[个人/公共]常用图片[{{title}}]吗？']: 'আপনি কি নিশ্চিত যে আপনি [ব্যক্তিগত/জনসাধারণের] সাধারণ ছবি [{{title}}] মুছে ফেলতে চান?',
	['一经确认删除无法复原。']: 'একবার নিশ্চিত করলে মুছে ফেলা পুনরুদ্ধার করা যাবে না।',
	['客服日志']: 'গ্রাহক সেবা লগ',
	['请输入内容等关键字']: 'অনুগ্রহ করে বিষয়বস্তু এবং মূলশব্দ লিখুন',
	['确认要删除[个人/公共]快捷语[{{title}}]：[{{content}}]吗？']: 'আপনি কি নিশ্চিত যে আপনি [ব্যক্তিগত/জনসাধারণের] সংক্ষিপ্ত বক্তব্য [{{title}}]: [{{content}}] মুছে ফেলতে চান?',
	['没有其他进入标签被开启，故无法关闭此进入标签']: 'অন্য কোন প্রবেশ ট্যাগ খোলা হয়নি, তাই এই প্রবেশ ট্যাগ বন্ধ করা সম্ভব নয়।',
	['没有其他进入标签被开启，故无法删除此标签']: 'আরও কোন এন্ট্রি ট্যাগ খোলা নেই, তাই এই ট্যাগটি মুছতে পারছি না।',
	['所有人']: 'সবাই',
	['自定义对象']: 'নিজস্ব অবজেক্ট',
	['套用对象']: 'অবজেক্ট প্রয়োগ',
	['回主画面']: 'মেইন স্ক্রীনে ফিরে যান',
	['孟加拉语']: 'বাংলা ভাষা',
	['繁体中文']: 'বাংলা',
	['简体中文']: 'সরল চীনা',
	['韩语']: 'বাংলা',
	['日语']: 'জাপানি',
	['葡萄牙语']: 'পর্তুগিজ',
	['印地语']: 'হিন্দি',
	['俄语']: 'রুশ ভাষা',
	['重要资讯']: 'গুরুত্বপূর্ণ তথ্য',
	['在对话中切换语言，在某些情况下，可能导致讯息翻译功能延迟约 10 分钟，影响新旧讯息的读取。确定要切换语言?']: 'সংলাপে ভাষা পরিবর্তন করা কিছু ক্ষেত্রে বার্তার অনুবাদের ফাংশনে প্রায় ১০ মিনিটের দেরি ঘটাতে পারে, নতুন ও পুরনো বার্তার পড়াশোনায় প্রভাব ফেলতে পারে। আপনি কি ভাষা পরিবর্তন করতে নিশ্চিত?',
	['暂无对话']: 'কিছু কথা নেই',
	['档案上传中']: 'ফাইল আপলোড হচ্ছে',
	['{{name}} 已于 {{time}} 开启自动推播']: '{{name}} {{time}} তে স্বয়ংক্রিয় বিজ্ঞাপন চালু করেছে',
	['{{name}} 已于 {{time}} 关闭自动推播']: '{{name}} {{time}} তে স্বয়ংক্রিয় নোটিফিকেশন বন্ধ করেছে',
	['商户代码']: 'মার্চেন্ট কোড',
	['请输入商户代码']: 'মার্চেন্ট কোড লিখুন',
	['密钥']: 'সিক্রেট কী',
	['请输入密钥']: 'সিক্রেট কী লিখুন',
	['共同设定']: 'সাধারণ সেটিং',
	['充值未到帐设定']: 'রিচার্জ না পৌঁছানো সেটিং',
	['出款未到帐设定']: 'উইথড্রয়াল না পৌঁছানো সেটিং',
	['确认进行储存？']: 'সংরক্ষণ নিশ্চিত করুন?',
	['SKILL开关']: 'SKILL সুইচ',
	['请输入SKILL']: 'SKILL লিখুন',
	['派单 API 参数']: 'অর্ডার ডিসপ্যাচ API প্যারামিটার',
	['请输入派单API URL']: 'অর্ডার ডিসপ্যাচ API URL লিখুন',
	['开单者username']: 'অর্ডার নির্মাতার ব্যবহারকারীর নাম',
	['请输入开单者username']: 'অর্ডার নির্মাতার ব্যবহারকারীর নাম লিখুন',
	['频道名称']: 'চ্যানেলের নাম',
	['请输入频道名称']: 'চ্যানেলের নাম লিখুন',
	['开单原因']: 'অর্ডারের কারণ',
	['请输入开单原因']: 'অর্ডারের কারণ লিখুন',
	['充值订单查询 API URL']: 'রিচার্জ অর্ডার কোয়েরি API URL',
	['出款订单查询 API URL']: 'উইথড্রয়াল অর্ডার কোয়েরি API URL',
	['同义词设定']: 'সমার্থক শব্দ নির্ধারণ',
	['开启BM25']: 'BM25 চালু করুন',
	['同义词']: 'পার্থক্য শব্দ',
	['更新时间']: 'সর্বশেষ আপডেট',
	['批次新增同义词']: 'ব্যাচে নতুন অভিন্ন শব্দ যোগ করুন',
	['修改同义词']: 'সংশোধন সমার্থক শব্দ',
	['新增同义词']: 'নতুন সমার্থক শব্দ সংযোজন',
	['请输入同义词，使用逗号区隔不同词汇']: 'একই অর্থের শব্দ লিখুন, আলাদা শব্দের জন্য কমা ব্যবহার করুন',
	['请以逗号区隔不同词汇，用分号区隔不同组同义词']: 'দয়া, অনুগ্রহ; ভদ্রতা; সদয়তা',
	['输入格式说明：']: 'এনপুট ফরম্যাট নির্দেশনা:',
	['请用，区隔不同词汇，例如：充值,储值,入金,课金']: 'অনুগ্রহ করে বিভিন্ন শব্দ আলাদা করতে কমা ব্যবহার করুন, যেমন: পুনর্ভরণ, সঞ্চয়, জমা, পাঠ্য অর্থ',
	['词汇与标点符号前后不要出现空白']: 'শব্দভাণ্ডারএবংপালচিহ্নেরসামনেেকোনওশূন্যস্থানথাকবেনা',
	['请用；或分行(enter)区隔同组同义词，例如：']: 'দয়া করে একই গ্রুপের সমার্থক শব্দগুলোকে ; বা লাইন-ব্রেক (enter) এর মাধ্যমে আলাদা করুন, যেমন:',
	['充值,储值,入金,课金']: '充值 - রিচার্জ  \n储值 - সংরক্ষণ  \n入金 - টাকা জমা  \n课金 - অর্থ প্রদান  ',
	['log in,登入;亲,宝贝']: 'লগ ইন, প্রবেশ করা; প্রিয়, সোনা',
	['请输入同义词']: 'একই অর্থের শব্দ লিখুন',
	['同义词不可为空']: 'সমার্থক শব্দ খালি থাকতে পারবে না',
	['同义词格式有误']: 'সাবধানতা ফরম্যাট ভুল আছে',
	['同义词不可有特殊字元']: 'একত্রিত শব্দের বিশেষ চরিত্র থাকতে হবে না',
	['字元不可超过10000']: 'অক্ষর ১০,০০০ এর বেশি হতে পারবে না',
	['需至少输入两个词汇']: 'কমপক্ষে দুটি শব্দ প্রদান করতে হবে',
	['删除同义词']: 'মেটানোর প্রতিশব্দ',
	['请确认是否删除同义词？']: 'দয়া করে নিশ্চিত করুন যে সমার্থক শব্দ মুছে ফেলা হবে?',
	['新增同义词成功']: 'নতুন প্রতিশব্দ সফলভাবে যুক্ত হয়েছে',
	['新增同义词失败']: 'নতুন প্রতিশব্দ যোগ করতে ব্যর্থ',
	['修改同义词成功']: 'সফলভাবে সংশোধন করা সমার্থক শব্দ',
	['修改同义词失败']: 'সংশোধন শব্দার্থ ব্যর্থ',
	['删除同义词成功']: 'সমার্থক শব্দ মুছে ফেলা সফল',
	['删除同义词失败']: '同义词বিভাজন অপ্রাপ্ত',
	['内容有重复字']: 'বিষয়টি পুনরাবৃত্তি রয়েছে',
	['新增图片，详细图片请参考公告管理']: 'নতুন ছবি যোগ করুন, বিস্তারিত ছবির জন্য দয়া করে বিজ্ঞপ্তি ব্যবস্থাপনা দেখুন।',
	['目前只支援ChatGPT进行微调训练']: 'বর্তমানে কেবল ChatGPT কে মাইক্রো টিউনিং প্রশিক্ষণ দেওয়ার জন্য সমর্থন করা হয়েছে।',
	['AI系列']: 'এআই সিরিজ',
	['AI系列不能为空']: 'এআই সিরিজ খালি থাকতে পারে না',
	['启用ChatGPT']: 'চ্যাটজিপিটি সক্রিয় করুন',
	['启用Gemini']: 'জেমিনি চালু করুন',
	['AI客服']: 'AI গ্রাহক সেবা',
	['ID入口']: 'ID প্রবেশপথ',
	['IP']: 'আইপি',
	['USER ID']: 'ব্যবহারকারী ID',
	['{{itemLabel}}內容不可为空']: '{{itemLabel}}বিষয়টি খালি হতে পারে না',
	['{{text}}仅能输入数字']: '{{text}}শুধুমাত্র সংখ্যা প্রবেশ করা যাবে',
	['{{text}}最多{{limit}}个字元']: '{{text}} সর্বাধিক {{limit}} টি অক্ষর',
	['{{text}}最多數字{{limit}}碼']: '{{text}}সর্বাধিক সংখ্যা{{limit}} অক্ষর',
	['{{time}}分']: '{{time}} মিনিট',
	['{{time}}时']: '{{time}} সময়',
	['{{time}}秒']: '{{time}} সেকেন্ড',
	['上一则发送后等待时间']: 'পূর্ববর্তী বার্তার পাঠানোর পরে অপেক্ষার সময়',
	['上传图片']: 'ছবি আপলোড করুন',
	['主要API keys']: 'মুখ্য API কীসমূহ',
	['主要语言']: 'প্রধান ভাষা',
	['事件']: 'ঘটনা',
	['以查看预览效果']: 'ভিউ প্রিভিউ দেখার জন্য',
	['依照选择模组设定UI显示位置及功能。']: 'মডিউল নির্বাচন অনুসারে UI প্রদর্শন অবস্থান এবং ফাংশন সেট করা।',
	['依照选择的风格进行调整配色（含背景、框体、配色、线条感）。']: 'নির্বাচিত শৈলীর অনুযায়ী রঙ সংশোধন করুন (পটভূমি, ফ্রেম, রঙ, লাইন বোধ অন্তর্ভুক্ত)।',
	['修改帐号履历成功']: 'অ্যাকাউন্টের ইতিহাস সফলভাবে সংশোধন করা হয়েছে',
	['修改翻译API成功']: 'অনুবাদ API সফলভাবে সংশোধন করা হয়েছে',
	['充值帐号']: 'রিচার্জ অ্যাকাউন্ট',
	['共 {{numOfItems}} 笔']: 'মোট {{numOfItems}}টি লেনদেন',
	['关 闭']: 'বন্ধ',
	['关闭后，整个推播系统将停止运作，所有推播讯息会暂时无效。您随时可以重新开启。']: 'বন্ধ করার পর, পুরো পুশ সিস্টেম কাজ করা বন্ধ করবে, সব পুশ বার্তা সাময়িকভাবে অকার্যকর হয়ে যাবে। আপনি যে কোনো সময় পুনরায় চালু করতে পারেন।',
	['内容最多20字元']: 'বিষয় সর্বোচ্চ 20 অক্ষর',
	['内容预览']: 'সামগ্রী পূর্বদৃশ্য',
	['切换后，跑马灯文字与快捷键可能会出现显示不清晰或对比度不足的情况，需到后台进行重新设定']: 'অবস্থান পরিবর্তনের পর, দৌড়ের বাতি লেখা এবং শর্টকাট কী সম্ভবত অস্পষ্ট বা অপেক্ষাকৃত লঘু প্রদর্শন করতে পারে, এটি পেছনের কার্যক্রমে পুনরায় নির্ধারণ করতে হবে।',
	['删除履历']: 'রিজেকশন মুছে দিন',
	['删除帐号履历成功']: 'অ্যাকাউন্ট ইতিহাস মুছে ফেলা হয়েছে সফলভাবে',
	['删除跑马灯']: 'মার্কিং মুছুন',
	['加载中...']: 'লোড হচ্ছে...',
	['勾选后，该账号在联系客服时，账号名称旁会显示']: 'যদি চেক করা হয়, তাহলে গ্রাহক পরিষেবার সাথে যোগাযোগ করার সময়, অ্যাকাউন্টের নামের পাশে প্রদর্শিত হবে',
	['即时预览']: 'তাত্ক্ষণিক প্রতিফলন',
	['取消新增微调文本']: 'মাইক্রো টেক্সট নতুন করার বাতিল করুন',
	['古典深色风格']: 'পাশ্চাত্য গা dark ় শৈলী',
	['單次']: 'একক',
	['回传表单']: 'প্রেরণ ফরম',
	['外观风格']: 'বাহ্যিক শৈলী',
	['客户端视觉设定']: 'ক্লায়েন্ট ভিজ্যুয়াল সেটিং',
	['客户端视觉设定成功']: 'ক্লায়েন্ট ভিজ্যুয়াল সেটআপ সফল',
	['尚无资料']: 'এখনও কোন তথ্য নেই',
	['展开']: 'বিস্তার করুন',
	['履历数量']: 'রেজেতে সংখ্যা',
	['帐号履历']: 'একাউন্ট ইতিহাস',
	['帐号履历管理']: 'অ্যাকাউন্ট ইতিহাস পরিচালনা',
	['平台代码不能有空白']: 'প্ল্যাটফর্ম কোডে ফাঁকা স্থান থাকতে পারবে না',
	['平台代码仅能输入英文和数字']: 'প্ল্যাটফর্মের কোড শুধুমাত্র ইংরেজি এবং সংখ্যা প্রবেশ করতে পারে',
	['平台代码最多5码']: 'প্ল্যাটফর্ম কোড সর্বাধিক ৫টি কোড',
	['平台代码最少2码']: 'প্ল্যাটফর্মের কোডে অন্তত ২টি সংখ্যা থাকতে হবে',
	['平台语言']: 'প্ল্যাটফর্ম ভাষা',
	['平均首次工作时间']: 'গড় প্রথম কর্মকাল',
	['建立者']: 'প্রতিষ্ঠাতা',
	['开关']: 'সুইচ',
	['快速通道']: 'দ্রুত পথ',
	['手动推播']: 'হাত দ্বারা প্রেরণ',
	['手机版']: 'মোবাইল ভার্সন',
	['批量删除']: 'বাল্ক মুছুন',
	['排序']: 'শ্রেণীবদ্ধকরণ',
	['推播功能']: 'পুশ বিজ্ঞপ্তি',
	['推播功能 OFF：推播功能关闭整个系统不运作，列表中的所有策略都无效。']: 'পুশ বিজ্ঞপ্তি ফিচার বন্ধ: পুশ বিজ্ঞপ্তি ফিচার পুরো সিস্টেমটি কাজ করছে না, তালিকায় থাকা সমস্ত কৌশল অকার্যকর।',
	['推播时间']: 'পুশ বিজ্ঞপ্তির সময়',
	['推播讯息列表']: 'পুশ নোটিফিকেশন তালিকা',
	['推播设定']: 'পুশ বিজ্ঞপ্তি সেটিং',
	['操作内容']: 'অপারেশন সম্পর্কিত বিষয়',
	['收起']: 'আবদ্ধ করা',
	['数值/内容']: 'সংখ্যা/বিষয়',
	['数值/内容不可为空']: 'মান/বিষয় খালি হতে পারে না',
	['数值只能输入数字、负号、小数点']: 'সংখ্যা কেবল সংখ্যা, নেতিবাচক চিহ্ন, দশমিক পয়েন্ট প্রবেশ করা যাবে',
	['数值小数最多6位数']: 'সংখ্যার দশমিক সর্বাধিক ৬ সংখ্যার।',
	['数值整数最多15位']: 'সংখ্যা পূর্ণসংখ্যা সর্বাধিক 15 অঙ্ক',
	['新增履历']: 'নতুন জীবনবৃত্তান্ত',
	['新增帐号履历成功']: 'একাউন্ট ইতিহাস সফলভাবে যুক্ত হয়েছে',
	['新增类型']: 'নতুন প্রকার',
	['无工作']: 'কাম নেই',
	['时间设定需至少为 3 分钟']: 'সময়ের নির্ধারণ অন্তত 3 মিনিট হতে হবে',
	['是否修改翻译API?']: 'কী অনুবাদ API পরিবর্তন করা হবে?',
	['更新成功']: 'সফল আপডেট',
	['更新者']: 'আপডেটার',
	['架构模组']: 'অভ্যন্তরীণ মডিউল',
	['栏位名称']: 'কলামের নাম',
	['栏位类型']: 'কলাম প্রকার',
	['栏位类型不可为空']: 'কলাম টাইপ খালি হতে পারবে না',
	['档案格式不符']: 'ফাইলের ফরম্যাট মিলছে না',
	['PDF文件']: 'PDF নথি',
	['模式与间隔时间']: 'মডেল এবং ব্যবধান সময়',
	['欢迎回来']: 'স্বাগতম ফিরে',
	['此操作将自动翻译其他语言，原有输入内容将被翻译结果覆盖，请确认是否继续？']: 'এই অপারেশনটি অন্যান্য ভাষাগুলিকে স্বয়ংক্রিয়ভাবে অনুবাদ করবে, পূর্বের ইনপুট সামগ্রীটি অনুবাদের ফলাফলের দ্বারা ওভাররাইট করা হবে, দয়া করে নিশ্চিত করুন যে আপনি অব্যাহত রাখতে চান?',
	['汇入']: 'মিশ্রণ',
	['汇入微调文本成功']: 'মাইক্রোফাইন টেক্সট সফলভাবে আমদানি করা হয়েছে',
	['汇出微调文本成功']: 'নিররত আউটপুট টেক্সট সফলভাবে সূক্ষ্মায়ন করা হয়েছে',
	['清空翻译']: 'শূন্য করা',
	['所有语系内容皆填写完成后才可确定，可使用自动翻译补齐其余语系']: 'নিশ্চিত করার আগে সব ভাষার বিষয়বস্তু সম্পূর্ণ করতে হবে। বাকি ভাষাগুলো পূরণ করতে স্বয়ংক্রিয় অনুবাদ ব্যবহার করা যায়।',
	['标题与内容皆需填写才可自动翻译']: 'স্বয়ংক্রিয় অনুবাদের আগে শিরোনাম ও বিষয়বস্তু উভয়ই পূরণ করতে হবে।',
	['状态持续时间']: 'স্থিতির স্থায়িত্ব',
	['用户帐号']: 'ব্যবহারকারী অ্যাকাউন্ট',
	['用户帐号不能为空']: 'ব্যবহারকারীর অ্যাকাউন্ট শূন্য হতে পারে না',
	['电脑版']: 'ডেস্কটপ',
	['目前无适用推播']: 'এখন কোনো কার্যকর বিজ্ঞপ্তি নেই',
	['目前有启用中的侦测语言平台，无法关闭']: 'বর্তমানে সক্রিয় ভাষা সনাক্তকরণ প্ল্যাটফর্ম রয়েছে, বন্ধ করা যাবে না',
	['确定删除IP白名单？']: 'আইপি সাদা তালিকা মুছে ফেলার বিষয়টি নিশ্চিত করছেন?',
	['确定发送推播？']: 'পুশ নোট পাঠানোর জন্য নিশ্চিত?',
	['确定要关闭推播功能吗？']: 'আপনি কি সত্যিই পুশ বিজ্ঞপ্তি কার্যকলাপ বন্ধ করতে চান?',
	['确认删除此笔履历?']: 'এই রেকর্ডটি মুছে ফেলার জন্য কি আপনি নিশ্চিত?',
	['确认要删除推播讯息？']: 'আপনি কি নিশ্চিতভাবে push বার্তা মুছতে চান?',
	['立即登入']: 'এখনই লগইন করুন',
	['第 {{min}} - {{max}} 笔/共 {{numOfItems}} 笔']: 'প্রথম {{min}} - {{max}} টি/মোট {{numOfItems}} টি',
	['筛选条件']: 'ছাঁকনি শর্ত',
	['类型名称']: 'প্রকারের নাম',
	['系统预设模组']: 'সিস্টেম প্রিসেট মডিউল',
	['经典浅色风格']: 'ক্লাসিক হালকা শৈলী',
	['翻译API']: 'অনুবাদ এপিআই',
	['聊天介面']: 'চ্যাট ইন্টারফেস',
	['自动推播']: 'স্বয়ংক্রিয় সতর্কীকরণ',
	['自动推播功能']: 'স্বয়ংক্রিয় পুশ বৈশিষ্ট্য',
	['自动推播功能 OFF：列表中的所有推播讯息虽然仍可被客服手动执行，但所有计时器功能停止运作。']: 'অটো পুশ ফাংশন বন্ধ: তালিকায় থাকা সব পুশ বার্তা যদিও এখনও কাস্টমার সার্ভিস দ্বারা ম্যানুয়ালি কার্যকর করা যেতে পারে, তবুও সব টাইমার ফাংশন কাজ বন্ধ হয়ে যায়।',
	['自定义']: 'কাস্টমাইজ',
	['自定义文案']: 'নিজস্ব লেখা',
	['自客服接起对话后开始计算']: 'গ্রাহক সেবার প্রতিনিধি কথোপকথন শুরু করার পর গণনা শুরু হয়।',
	['该类型目前有推播讯息套用中，无法删除']: 'এই ধরনের বর্তমানে পুশ বার্তা প্রয়োগ হচ্ছে, মুছতে পারছি না।',
	['详细说明']: 'বিস্তারিত বর্ণনা',
	['请先选择推播类型']: 'অনুগ্রহ করে প্রথমে পুশ বিজ্ঞপ্তির ধরনের নির্বাচন করুন',
	['请确认是否批量删除(共 {{selectedFineTuningRecordsLength}} 笔)？']: 'দয়া করে নিশ্চিত করুন যে আপনি কি একাধিক মুছে ফেলার জন্য (মোট {{selectedFineTuningRecordsLength}} টি) যাচ্ছেন?',
	['请输入事件']: 'অনুগ্রহ করে ঘটনা প্রবেশ করান',
	['请输入会员ID']: 'দয়া করে সদস্য আইডি লিখুন',
	['请输入內容']: 'আমার বিষয়বস্তু প্রবেশ করুন',
	['请输入关键字']: 'প্রবিষ্ট করুন কীওয়ার্ড',
	['请输入您的会员 ID 以继续']: 'আপনার সদস্য আইডি প্রবেশ করুন যাতে এগিয়ে যেতে পারেন',
	['请输入数值/内容']: 'দয়া করে মান/বিষয় বসান',
	['请输入文字']: 'অনুগ্রহ করে পাঠ্য প্রবেশ করুন',
	['请输入栏位名称']: 'অনুগ্রহ করে কলামের নাম লিখুন',
	['请输入用户帐号']: 'দয়া করে ব্যবহারকারীর একাউণ্ট প্রবেশ করান',
	['请输入类型名称']: 'টাইপের নাম লিখুন',
	['请输入详细说明']: 'দয়া করে বিস্তারিত বিবরণ দিন',
	['请选择上方下拉选单']: 'উপরের ড্রপডাউন মেনু থেকে নির্বাচন করুন',
	['请选择主要语言自动翻译']: 'দয়া করে প্রধান ভাষা নির্বাচন করুন স্বয়ংক্রিয়ভাবে অনুবাদ করুন',
	['请选择帐号状态']: 'অ্যাকাউন্টের অবস্থা নির্বাচন করুন',
	['请选择平台']: 'প্ল্যাটফর্ম নির্বাচন করুন',
	['请选择推播项目']: 'অনুগ্রহ করে পুশ বিজ্ঞপ্তি নির্বাচন করুন',
	['请选择栏位类型']: 'বারের প্রকার নির্বাচন করুন',
	['请选择类型']: 'প্রকার নির্বাচন করুন',
	['请选择类型与项目(标题)以预览内容']: 'অনুগ্রহ করে বাছাই করুন প্রকার এবং প্রকল্প (শিরোনাম) সামগ্রীর পূর্বদর্শনের জন্য',
	['请选择表单选项']: 'ফর্ম অপশন নির্বাচন করুন',
	['请选择运算规则']: 'কৃপাতি নিয়ম নির্বাচন করুন',
	['请选择预览画面']: 'দয়া করে প্রাক দৃশ্য নির্বাচন করুন',
	['跑马灯设定']: 'রানিং লাইট সেটিং',
	['轮播']: 'স্লাইডশো',
	['轮播模式']: 'কারousel মোড',
	['轮播间隔时间']: 'স্লাইডার বিরতি সময়',
	['运算规则']: 'গণনা নিয়ম',
	['运算规则不可为空']: 'গণনা নীতি স্মৃতি খালি হতে পারে না',
	['返回上一层']: 'পেছনে ফিরে যাও',
	['返回上一页']: 'পেছনে ফিরে যান',
	['送出推播']: 'পুশ প্রেরণ',
	['选单介面']: 'মেনু ইন্টারফেস',
	['选择推播类型']: 'পুশ বিজ্ঞাপন ধরন নির্বাচন করুন',
	['选择推播项目(标题)']: 'বিজ্ঞপ্তি নির্বাচন করুন (শিরোনাম)',
	['通知时间']: 'নোটিশ সময়',
	['通知时间不能为空']: 'নোটিফিকেশন সময় শূন্য হতে পারে না',
	['重新产生Key/IV']: 'কী/আইভি পুনরায় উত্পন্ন করুন',
	['重要客户']: 'গুরুতর গ্রাহক',
	['需为1~60正整数']: '১~৬০ গুণাঙ্ক হওয়া আবশ্যক',
	['预估时间']: 'অনুমানিত সময়',
	['预览图片']: 'চিত্র পূর্বরূপ',
	['首次工作时间报表']: 'প্রথম কাজের সময়ের রিপোর্ট',
	['日志管理']: 'লগ ব্যবস্থাপনা',
	['API传送日志']: 'API ট্রান্সমিশন লগ',
	['订单号']: 'অর্ডার নম্বর',
	['三方单号']: 'তৃতীয় পক্ষের অর্ডার নম্বর',
	['请输入订单号']: 'অনুগ্রহ করে অর্ডার নম্বর প্রবেশ করান',
	['请输入三方单号']: 'অনুগ্রহ করে তৃতীয় পক্ষের অর্ডার নম্বর প্রবেশ করান',
	['充值订单查询']: 'রিচার্জ অর্ডার অনুসন্ধান',
	['出款订单查询']: 'উত্তোলন অর্ডার অনুসন্ধান',
	['开派单']: 'ডিসপ্যাচ অর্ডার তৈরি করুন',
	['传送派单信息']: 'ডিসপ্যাচ তথ্য পাঠান',
	['CS传送资料']: 'CS পাঠানো ডেটা',
	['平台回覆资料']: 'প্ল্যাটফর্ম প্রতিউত্তর ডেটা',
	['{{text}}需以{{prefix}}开头']: '{{-text}} অবশ্যই {{-prefix}} দিয়ে শুরু হতে হবে',
	['系统通知']: 'সিস্টেম বিজ্ঞপ্তি',
	['派单传送讯息']: 'ডিসপ্যাচ বার্তা পাঠান',
	['派单传送档案']: 'ডিসপ্যাচ ফাইল পাঠান',
	['请输入平台']: 'অনুগ্রহ করে প্ল্যাটফর্ম লিখুন',
	['派单讯息润饰设定']: 'ডিসপ্যাচ বার্তা পরিমার্জন সেটিং',
	['此指令不会载入「AI共同设定」与「平台AI设定」，为独立的 Agent 使用']: 'এই নির্দেশনা "AI সম্মিলিত নির্ধারণ" এবং "প্ল্যাটফর্ম AI সেটিং" লোড করে না; একটি স্বতন্ত্র Agent হিসাবে ব্যবহৃত হয়',
	['用户个人设定']: 'ব্যবহারকারীর ব্যক্তিগত সেটিং',
	['新增用户个人资讯']: 'ব্যবহারকারীর ব্যক্তিগত তথ্য যোগ করুন',
	['个人资讯参数名称']: 'ব্যক্তিগত তথ্য প্যারামিটারের নাম',
	['请输入个人资讯参数名称']: 'অনুগ্রহ করে ব্যক্তিগত তথ্য প্যারামিটারের নাম লিখুন',
	['*新增多个请使用逗号「 , 」隔开']: '*একাধিক যোগ করতে অনুগ্রহ করে কমা「 , 」দিয়ে আলাদা করুন',
	['用来设定该平台哪些个人资讯要丢给AI，只有设定在「用户个人设定」的参数，才会传送给AI']: 'এই প্ল্যাটফর্মের কোন ব্যক্তিগত তথ্য AI-কে পাঠানো হবে তা নির্ধারণ করতে ব্যবহৃত হয়। শুধুমাত্র "ব্যবহারকারীর ব্যক্তিগত সেটিং"-এ নির্ধারিত প্যারামিটারগুলোই AI-কে পাঠানো হবে',
	['批次删除用户个人资讯']: 'ব্যবহারকারীর ব্যক্তিগত তথ্য ব্যাচ মুছে ফেলুন',
	['确定要批次删除用户个人资讯吗？']: 'আপনি কি নিশ্চিত যে ব্যবহারকারীর ব্যক্তিগত তথ্য ব্যাচে মুছে ফেলতে চান?',
	['个人资讯参数名称不能为空']: 'ব্যক্তিগত তথ্য প্যারামিটারের নাম খালি রাখা যাবে না',
	['已存在「{{name}}」']: '「{{-name}}」ইতিমধ্যে বিদ্যমান',
	['最多可新增{{limit}}个，已超过上限']: 'সর্বাধিক {{-limit}}টি যোগ করা যাবে, সীমা অতিক্রম করেছে',
	['新增用户个人资讯成功']: 'ব্যবহারকারীর ব্যক্তিগত তথ্য সফলভাবে যোগ করা হয়েছে',
	['新增用户个人资讯失败']: 'ব্যবহারকারীর ব্যক্তিগত তথ্য যোগ করতে ব্যর্থ',
	['删除用户个人资讯成功']: 'ব্যবহারকারীর ব্যক্তিগত তথ্য সফলভাবে মুছে ফেলা হয়েছে',
	['删除用户个人资讯失败']: 'ব্যবহারকারীর ব্যক্তিগত তথ্য মুছে ফেলতে ব্যর্থ',
	['图像管理']: 'ছবি ব্যবস্থাপনা',
	['自定义图像']: 'কাস্টম ছবি',
	['档案格式：“PNG、JPG”档案大小不得大于 500KB']: 'ফাইল ফরম্যাট: "PNG, JPG", ফাইলের আকার 500KB এর বেশি হতে পারবে না',
	['档案最大500K']: 'ফাইল সর্বোচ্চ 500K',
	['新增图像成功']: 'ছবি সফলভাবে যোগ করা হয়েছে',
	['删除图像成功']: 'ছবি সফলভাবে মুছে ফেলা হয়েছে',
	['是否确定删除图像？']: 'আপনি কি নিশ্চিতভাবে এই ছবিটি মুছে ফেলতে চান?',
	['内容设定']: 'বিষয়বস্তু নির্ধারণ',
	['英语']: 'ইংরেজি',
	['{{language}}内容']: '{{language}} বিষয়বস্তু',
	['请输入{{language}}内容']: 'দয়া করে {{language}} বিষয়বস্তু লিখুন',
	['请选择时间']: 'অনুগ্রহ করে সময় নির্বাচন করুন',
	['请选择公司']: 'অনুগ্রহ করে কোম্পানি নির্বাচন করুন',
	['请输入{{label}}']: 'দয়া করে {{label}} লিখুন',
	['原文参考（{{language}}）']: 'মূল পাঠ্যের রেফারেন্স ({{language}})',
	['确定清空设定吗？']: 'আপনি কি নিশ্চিতভাবে সেটিংস মুছে ফেলতে চান?',
	['确定取消设定吗？']: 'আপনি কি নিশ্চিতভাবে সেটিংস বাতিল করতে চান?',
	['{{language}}{{tab}}']: '{{language}} {{tab}}',
	['未完成']: 'অসম্পূর্ণ',
	['{{language}}{{label}}超过{{limit}}字']: '{{language}} {{label}} {{limit}}টি অক্ষরের বেশি',
	['公告标题']: 'ঘোষণার শিরোনাম',
	['进线IP']: 'ইনকামিং IP',
	['请输入进线IP']: 'ইনকামিং IP লিখুন',
	['模型切换：{{fromModel}} -> {{toModel}}']: 'মডেল পরিবর্তন: {{fromModel}} -> {{toModel}}',
	['包网后台删除帐号后，客服系统帐号将同步删除']: 'BW ব্যাকএন্ডে অ্যাকাউন্ট মুছে ফেলার পরে, গ্রাহক পরিষেবা সিস্টেমের অ্যাকাউন্ট সিঙ্ক্রোনাসভাবে মুছে ফেলা হবে',
	['系统已有新版本，请重新整理']: 'নতুন সংস্করণ উপলব্ধ, দয়া করে পুনরায় রিফ্রেশ করুন',
	['页面加载失败，请重试']: 'পৃষ্ঠা লোড করতে ব্যর্থ, অনুগ্রহ করে আবার চেষ্টা করুন',
	['翻译中']: 'অনুবাদ করা হচ্ছে',
	['监控与即时摘要设定']: 'পর্যবেক্ষণ ও তাৎক্ষণিক সারাংশ সেটিং',
	['批量转接']: 'ব্যাচ সংযোগ',
	['已选 {{count}} 则对话']: '{{count}} টি কথোপকথন নির্বাচিত',
	['勾选']: 'নির্বাচন',
	['全平台服务人数']: 'সমস্ত প্ল্যাটফর্মে সেবা সংখ্যা',
	['未开启{{platform}}平台']: '{{-platform}} প্ল্যাটফর্ম চালু করা হয়নি',
	['成功由 {{inviter}} 转接至 {{invitee}}，共 {{count}} 则']: '{{-inviter}} থেকে {{-invitee}} এ সফলভাবে স্থানান্তর, মোট {{count}} টি।',
	['接受']: 'গ্রহণ করুন',
	['拒绝({{seconds}}S)']: 'প্রত্যাখ্যান({{seconds}}S)',
	['生成链接']: 'লিংক তৈরি করুন',
	['链接生成中...']: 'লিংক তৈরি হচ্ছে...',
	['复制链接']: 'লিংক কপি করুন',
	['已复制链接']: 'লিংক কপি হয়েছে',
	['档案上传失败']: 'ফাইল আপলোড ব্যর্থ হয়েছে',
	['转档失败，请重新上传']: 'রূপান্তর ব্যর্থ হয়েছে, অনুগ্রহ করে আবার আপলোড করুন',
	['人工回复']: 'ম্যানুয়াল উত্তর',
	['检视回复']: 'উত্তর দেখুন',
	['{{time}} AI 拦截对话']: '{{time}} AI কথোপকথন থামিয়েছে',
	['AI 拦截原因与人工回复']: 'AI থামানোর কারণ ও ম্যানুয়াল উত্তর',
	['人工回复失败']: 'ম্যানুয়াল উত্তর ব্যর্থ হয়েছে',
	['回复讯息']: 'উত্তরের বার্তা',
	['对话摘要']: 'কথোপকথনের সারসংক্ষেপ',
	['建议回复']: 'প্রস্তাবিত উত্তর',
	['拦截原因']: 'থামানোর কারণ',
	['拦截回复']: 'থামানো উত্তর',
	['确定送出']: 'নিশ্চিত করে পাঠান',
	['生成链接失败']: 'লিংক তৈরি করতে ব্যর্থ হয়েছে',
	['连接超时，请稍后再试']: 'সংযোগের সময় শেষ হয়ে গেছে, অনুগ্রহ করে পরে আবার চেষ্টা করুন',
	['上一则']: 'পূর্ববর্তী',
	['下一则']: 'পরবর্তী',
	['重新传送']: 'পুনরায় পাঠান',
	['传送中...']: 'পাঠানো হচ্ছে...',
	['用户端翻译失败']: 'ব্যবহারকারীর জন্য অনুবাদ ব্যর্থ হয়েছে',
	['重新传送失败']: 'পুনরায় পাঠানো ব্যর্থ হয়েছে',
	['请确认是否删除以下模型？']: 'নিচের মডেলটি মুছে ফেলা নিশ্চিত করবেন?',
	['新增模型']: 'মডেল যোগ করুন',
	['请选择AI系列']: 'অনুগ্রহ করে AI সিরিজ নির্বাচন করুন',
	['支援模型']: 'সমর্থিত মডেল',
	['支援模型不能为空']: 'সমর্থিত মডেল খালি রাখা যাবে না',
	['请选择支援模型']: 'অনুগ্রহ করে সমর্থিত মডেল নির্বাচন করুন',
	['AI模型管理']: 'AI মডেল ব্যবস্থাপনা',
	['模型不能为空']: 'মডেল খালি রাখা যাবে না',
	['请选择模型']: 'অনুগ্রহ করে মডেল নির্বাচন করুন',

	['对话类型']: 'সংলাপের ধরন',
	['单纯AI讯息']: 'শুধুমাত্র এআই বার্তা',
	['单纯人员讯息']: 'শুধুমাত্র কর্মী বার্তা',
	['人员+AI讯息']: 'কর্মী + এআই বার্তা',
	['是否经过AI拦截']: 'এআই দ্বারা বাধা দেওয়া হয়েছে কি?',
	['是否修改AI拦截建议回覆']: 'এআই প্রস্তাবিত উত্তর সংশোধন করা হয়েছে কি?',
	['监控API keys']: 'পর্যবেক্ষণ API কীসমূহ',
	['管理']: 'পরিচালনা',

	['启用显性快取']: 'এক্সপ্লিসিট ক্যাশ চালু করুন',
	['AI监控拦截总量']: 'এআই পর্যবেক্ষণ বাধা মোট',
	['AI监控拦截']: 'এআই পর্যবেক্ষণ বাধা',
	['有修改建议回覆总量']: 'সংশোধিত প্রস্তাবিত উত্তর সহ',
	['触发关键字：{{keywords}}。']: 'ট্রিগার হওয়া কীওয়ার্ড: {{-keywords}}।',

	['版面已套用，但尚未同步至帐号']: 'লেআউট প্রয়োগ করা হয়েছে, তবে অ্যাকাউন্টে এখনও সিঙ্ক হয়নি',
	['服务器重设失败，下次开启工作区时会再同步']: 'সার্ভারে রিসেট ব্যর্থ হয়েছে, পরেরবার ওয়ার্কস্পেস খুললে আবার সিঙ্ক হবে',
	['浏览器无法储存版面，离开前请确认帐号同步完成']: 'ব্রাউজার লেআউট সংরক্ষণ করতে পারছে না, চলে যাওয়ার আগে অ্যাকাউন্ট সিঙ্ক সম্পূর্ণ হয়েছে কিনা নিশ্চিত করুন',

	['重设版面配置']: 'লেআউট রিসেট করুন',
	['确定要将版面配置回复为系统预设吗？']: 'লেআউট সিস্টেমের ডিফল্টে ফিরিয়ে আনতে চান?',
	['客服支援语言']: 'গ্রাহক সেবা সমর্থিত ভাষা',
	['请选择支援语言']: 'অনুগ্রহ করে সমর্থিত ভাষা নির্বাচন করুন',
	['请选择客服支援语言']: 'অনুগ্রহ করে গ্রাহক সেবা সমর্থিত ভাষা নির্বাচন করুন',

	['删除平台']: 'প্ল্যাটফর্ম মুছুন',
	['是否确定删除{{code}}平台']: 'আপনি কি নিশ্চিত যে {{-code}} প্ল্যাটফর্ম মুছতে চান?',
	['删除{{code}}平台成功']: '{{-code}} প্ল্যাটফর্ম সফলভাবে মুছে ফেলা হয়েছে',
	['上传图片或PDF']: 'ছবি বা PDF আপলোড করুন',
	['当前平台维护中，如有疑问请联系管理员']: 'বর্তমান প্ল্যাটফর্মটি রক্ষণাবেক্ষণের মধ্যে রয়েছে। কোনো প্রশ্ন থাকলে প্রশাসকের সাথে যোগাযোগ করুন।',
	['当前平台已禁用，如有疑问请联系管理员']: 'বর্তমান প্ল্যাটফর্মটি নিষ্ক্রিয় করা হয়েছে। কোনো প্রশ্ন থাকলে প্রশাসকের সাথে যোগাযোগ করুন।',
	['收回提示文字']: 'প্রত্যাহারের প্রম্পট টেক্সট',
	['请输入提示文字，例如：抱歉亲 妹子发错了更正一下哦！']: 'অনুগ্রহ করে প্রম্পট লিখুন, যেমন: দুঃখিত! ভুল করে পাঠানো হয়েছে আমি এটি সংশোধন করছি!',
	['标签名称']: 'লেবেলের নাম',
	['预览失败']: 'প্রিভিউ ব্যর্থ হয়েছে',
	['放大']: 'বড় করুন',
	['缩小']: 'ছোট করুন',
	['上一页']: 'পূর্ববর্তী পৃষ্ঠা',
	['下一页']: 'পরবর্তী পৃষ্ঠা',
	['点击预览']: 'প্রিভিউ করতে ক্লিক করুন',
};
